document.addEventListener("DOMContentLoaded", function() {

async function uploadToDrive(base64, filename = "upload.png") {
  const blob = await (await fetch(`data:image/png;base64,${base64}`)).blob();
  const formData = new FormData();
  formData.append("image", blob, filename);

  try {
    const response = await fetch("https://api.beast90.com/api/upload-image-to-drive", {
      method: "POST",
      body: formData,
    });

    const result = await response.json();
    if (response.ok && result.url) {
      return result.url;
    } else {
      throw new Error(result.error || "Upload failed");
    }
  } catch (err) {
    console.error("Upload to Drive failed:", err);
    return "";
  }
}



const imagesToPreload = [
    'Gold1.png', 'Gold2.png', 'Samba.png', 'hero.png', 'neon.png',
    'eternal.png', 'cosmic.png', 'uncharted-icon.png', 'crystal.png',
    'uncharted.png', 'icon.png', 'galaxy.png', 'tots.png', 'iconfc26.png', 'herofc26.png', 'totwfc26.png'
  ];

  imagesToPreload.forEach(imgName => {
    const img = new Image();
    img.src = `https://cdn.shopify.com/s/files/1/0632/7094/4858/files/${imgName}`;
  });



const cardContainer = document.getElementById("football-card-creator");
  const params        = new URLSearchParams(window.location.search);
  const variantId     = params.get("variant");

  // 1) Map any variant IDs to style keys
  const variantStyleMap = {
    "41838045200474": "Gold1",
    "41869602062426": "Gold2", //Small
    "41869602095194": "Gold2", //Medium
    "41869602127962": "Gold2", //Large
    "41869522600026": "Samba", //Small
    "41869522632794": "Samba", //Medium
    "41869522665562": "Samba", //Large
    "41869552517210": "Neon", //Small
    "41869552549978": "Neon", //Medium
    "41869552582746": "Neon", //Large
    "41839050260570": "Eternal", //Small
    "41839050293338": "Eternal", //Medium
    "41839050326106": "Eternal", //Large
    "41839049834586": "Cosmic", //Small
    "41839049867354": "Cosmic", //Medium
    "41839049900122": "Cosmic", //Large
    "41839051047002": "UnchartedIcon", //Small
    "41839051079770": "UnchartedIcon", //Medium
    "41839051112538": "UnchartedIcon", //Large
    "41927659094106": "Crystal", //Small
    "41927659126874": "Crystal", //Medium
    "41927659159642": "Crystal", //Large
    "41927655161946": "Uncharted", //Small
    "41927655194714": "Uncharted", //Medium
    "41927655227482": "Uncharted", //Large
    "41869521256538": "Icon", //Small
    "41869521289306": "Icon", //Medium
    "41869521322074": "Icon", //Large
    "41839012872282": "Hero", //Small
    "41839012905050": "Hero", //Medium
    "41839012937818": "Hero", //Large
    "41839049441370": "Galaxy", //Small
    "41839049474138": "Galaxy", //Medium
    "41839049506906": "Galaxy", //Large
    "41839053078618": "TOTS", //Small
    "41839053111386": "TOTS", //Medium
    "41839053144154": "TOTS", //Large

    "42014066278490": "IconFC26", //Small
    "42014066311258": "IconFC26", //Medium
    "42014066344026": "IconFC26", //Large
    "42014067392602": "HeroFC26", //Small
    "42014067425370": "HeroFC26", //Medium
    "42014067458138": "HeroFC26", //Large
    "42014066868314": "totwFC26", //Small
    "42014066901082": "totwFC26", //Medium
    "42014066933850": "totwFC26" //Large

  };

  const styleKey = variantStyleMap[variantId] || "Gold1";
updateLeagueLogoBasedOnStyle();



 const styleThemeMap = {
    Gold1: 'gold-theme',
    Gold2: 'gold-theme',

    Samba: 'samba-theme',

    Icon: 'icon-theme',
    UnchartedIcon: 'icon-theme',
    IconFC26: 'icon-theme',

    Neon: 'neon-theme',

    TOTS: 'yellow-theme',
    totwFC26: 'yellow-theme',
    Galaxy: 'yellow-theme',
    Uncharted: 'yellow-theme',

    Hero:  'white-theme',
    HeroFC26:  'white-theme',
    Eternal:  'white-theme',
    Cosmic:  'white-theme',
    Crystal:  'white-theme'

  };

 function updateLeagueLogoBasedOnStyle() {
  const leagueInput = document.getElementById("league-input");
  const logo = document.getElementById("league-logo");
  if (!leagueInput || !logo) return;

  const selectedLeague = leagueInput.value.trim();

  // Avoid overriding if a custom logo is uploaded
  if (window.customLeagueBase64) return;

  // ✅ List of styles that should trigger the purple Premier League logo
  const purpleStyles = ["Gold1", "Gold2", "Icon", "UnchartedIcon","IconFC26"];

  if (purpleStyles.includes(styleKey) && selectedLeague === "EPL") {
    logo.src = leagues["EPL (Purple)"];
  } else {
    logo.src = leagues[selectedLeague] || "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknown-league.png";
  }

  logo.style.display = "block";
}



  const themeClass = styleThemeMap[styleKey] || 'gold-theme';

  cardContainer.classList.forEach(cls => {
    if (cls.endsWith('-theme')) {
      cardContainer.classList.remove(cls);
    }
  });

  // 3) apply the new one
  cardContainer.classList.add(themeClass);

const cardStylesMap = {
  Gold1: "Gold1.png",
  Gold2: "Gold2.png",
  Samba: "Samba.png",
  Hero: "hero.png",
  Neon: "neon.png",
  Eternal: "eternal.png",
  Cosmic: "cosmic.png",
  UnchartedIcon: "uncharted-icon.png",
  Crystal: "crystal.png",
  Uncharted: "uncharted.png",
  Icon: "icon.png",
  Hero: "hero.png",
  Galaxy: "galaxy.png",
  TOTS: "tots.png",
  IconFC26: "iconfc26.png",
  HeroFC26: "herofc26.png",
  totwFC26: "totwfc26.png"

};

 // 4) Pick the file, falling back to Hero
  const filename = cardStylesMap[styleKey] || cardStylesMap["Gold1"];

  if (styleKey === 'Samba') {
  cardContainer.classList.add('samba-theme');
} else {
  cardContainer.classList.remove('samba-theme');
}

function applyMaskOnceReady() {
  const cardContent = document.getElementById("card-content");
  if (!cardContent) {
    // Retry in 100ms if not yet present
    return setTimeout(applyMaskOnceReady, 100);
  }

  if (styleKey === "Gold1" || styleKey === "Gold2") {
    const goldMaskUrl = "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Gold2.png";
    cardContent.style.maskImage = `url('${goldMaskUrl}')`;
    cardContent.style.webkitMaskImage = `url('${goldMaskUrl}')`;
    cardContent.style.maskSize = 'contain';
    cardContent.style.maskRepeat = 'no-repeat';
    cardContent.style.maskPosition = 'center';
    cardContent.style.webkitMaskSize = 'contain';
    cardContent.style.webkitMaskRepeat = 'no-repeat';
    cardContent.style.webkitMaskPosition = 'top';
  }
}


  // Append custom CSS for placeholders, non-selectable content, and corner handles
  const style = document.createElement("style");
  style.textContent = `

.samba-theme #card-rating,
.samba-theme #card-position,
.samba-theme #card-name,
.samba-theme #stat-labels {
  color: #fdd102 !important;
}

.icon-theme #card-rating,
.icon-theme #card-position,
.icon-theme #card-name,
.icon-theme #stat-labels {
  color: #4d391e !important;
}

.neon-theme #card-rating,
.neon-theme #card-position,
.neon-theme #card-name,
.neon-theme #stat-labels {
  color: #d0fb11 !important;
}

.yellow-theme #card-rating,
.yellow-theme #card-position,
.yellow-theme #card-name,
.yellow-theme #stat-labels {
  color: #f4d98b !important;
}

.white-theme #card-rating,
.white-theme #card-position,
.white-theme #card-name,
.white-theme #stat-labels {
  color: white !important;
}
  #background-remover-message{
  font-weight: lighter;
    padding: 25px 0px;
    font-size: 12px;
    letter-spacing: normal;
    font-family: 'Sora';
  }

  a[href="/collections/personalized-football-cards"] {
  color: red;
  font-weight: bold;
}

.blue-buttons-card-creator {
  border: none;
  margin-top: 20px;
  width: 55%;
  border-radius: 50px;
  padding: 20px;
  min-height: 64px;
  font-size: 20px;
  font-weight: bold;
  color: white;
  background-image: linear-gradient(to right, #7ebeff, #007eff);
  background-position: 0% 0%;
  transition: background-position 0.4s ease;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.doubly-float {
  display: none !important;
}

@keyframes loadingGradient {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}


.custom-upload-icon {
  max-width: 50px;

}

.custom-span-upload{
    font-family: 'cruyff_condensed_medium';
    font-weight: 500;
    text-transform: uppercase;
    font-size: 22px;
}

    #brightness-slider,
  #contrast-slider {
    -webkit-appearance: none;
    width: 100%;
    height: 8px;
    background: #374151; /* dark gray */
    border-radius: 5px;
    outline: none;
    margin-top: 10px;
    margin-bottom: 10px;
    transition: background 0.3s;
  }

  /* Slider thumb */
  #brightness-slider::-webkit-slider-thumb,
  #contrast-slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    border: 2px solid #1f2937; /* slightly darker border */
    transition: background 0.3s;
  }

  html, body {
  touch-action: manipulation;
  overflow-x: hidden;
  touch-action: pan-y;
}

.card-builder,football-card-preview,#card-image,#card-content{
overflow-x: hidden;
}


  /* Firefox thumb */
  #brightness-slider::-moz-range-thumb,
  #contrast-slider::-moz-range-thumb {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    cursor: pointer;
    border: 2px solid #1f2937;
  }

  /* Labels */
  label[for="brightness-slider"],
  label[for="contrast-slider"] {
    color: white;
    font-size: 20px;
    margin-right: 8px;
  }

    #player-card-image-container {
  touch-action: none; /* Important for mobile dragging and resizing */
  overscroll-behavior: contain;
}

.corner-handle {
  width: 14px;
  height: 14px;
  background: white;
  border: 2px solid black;
  border-radius: 50%;
  position: absolute;
  pointer-events: auto;
  z-index: 0;
  cursor: nwse-resize;
}

.corner-top-left { top: -7px; left: -7px; cursor: nwse-resize; }
.corner-top-right { top: -7px; right: -7px; cursor: nesw-resize; }
.corner-bottom-left { bottom: -7px; left: -7px; cursor: nesw-resize; }
.corner-bottom-right { bottom: -7px; right: -7px; cursor: nwse-resize; }


    .language-option{
    background-color: #374151;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    gap: 6px;
    color: white;
    font-size: 15px;
    border: none;
    border-radius: 9999px;
    cursor: pointer;
    font-family: 'Tomorrow', sans-serif;

    }

    .data-entry-styled:focus {
  outline: none!important;
    border: none!important;
    box-shadow: none!important;
}

.data-entry-styled{
    margin-bottom: 10px;
    padding: 31.4px 0px!important;
    width: 100%;
    padding-left: 15px!important;
    font-size: 20px!important;
    text-align: left;
    text-align-last: left;
    border: none!important;
    color: white!important;
    margin: 0!important;
}


.data-entry-styled:nth-child(odd) {
  background-color: #24293d; /* dark background */
}

.data-entry-styled:nth-child(even) {
  background-color: #383f49; /* slightly lighter background */
}

    .league-suggestion {
  opacity: 1;
  transform: translateY(5px);
}

.league-suggestion:nth-child(1) { animation-delay: 0s; }
.league-suggestion:nth-child(2) { animation-delay: 0.03s; }
.league-suggestion:nth-child(3) { animation-delay: 0.06s; }
.league-suggestion:nth-child(4) { animation-delay: 0.09s; }
.league-suggestion:nth-child(5) { animation-delay: 0.12s; }
.league-suggestion:nth-child(6) { animation-delay: 0.15s; }
.league-suggestion:nth-child(7) { animation-delay: 0.18s; }
.league-suggestion:nth-child(8) { animation-delay: 0.21s; }
.league-suggestion:nth-child(9) { animation-delay: 0.24s; }

.league-suggestion {
  display: flex;
  align-items: center;
  background-color: #374151;
  color: white;
  font-size: 13px;
  font-family: 'Tomorrow', sans-serif;
  border: none;
  cursor: pointer;
  flex-direction: column;
  transition: background-color 0.2s ease;
}
.league-suggestion:hover {
  background-color: #1f2937;
}
.league-suggestion:nth-child(odd) {
  background-color: #24293d;
}
.league-suggestion:nth-child(even) {
  background-color: #383f49;
}


    .player-image-bg-mask {
  background-color: white;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  mix-blend-mode: screen; /* lightens the dark transparent areas */
  pointer-events: none;
}


 .country-suggestion {
    opacity: 0;
    transform: translateY(5px);
    animation: fadeInUp 0.3s ease forwards;
  }

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .country-suggestion:nth-child(1) { animation-delay: 0s; }
  .country-suggestion:nth-child(2) { animation-delay: 0.03s; }
  .country-suggestion:nth-child(3) { animation-delay: 0.06s; }
  .country-suggestion:nth-child(4) { animation-delay: 0.09s; }
  .country-suggestion:nth-child(5) { animation-delay: 0.12s; }
  .country-suggestion:nth-child(6) { animation-delay: 0.15s; }
  .country-suggestion:nth-child(7) { animation-delay: 0.18s; }
  .country-suggestion:nth-child(8) { animation-delay: 0.21s; }
  .country-suggestion:nth-child(9) { animation-delay: 0.24s; }

    .club-suggestion {
    opacity: 0;
    transform: translateY(5px);
    animation: fadeInUp 0.3s ease forwards;
  }

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .club-suggestion:nth-child(1) { animation-delay: 0s; }
  .club-suggestion:nth-child(2) { animation-delay: 0.03s; }
  .club-suggestion:nth-child(3) { animation-delay: 0.06s; }
  .club-suggestion:nth-child(4) { animation-delay: 0.09s; }
  .club-suggestion:nth-child(5) { animation-delay: 0.12s; }
  .club-suggestion:nth-child(6) { animation-delay: 0.15s; }
  .club-suggestion:nth-child(7) { animation-delay: 0.18s; }
  .club-suggestion:nth-child(8) { animation-delay: 0.21s; }
  .club-suggestion:nth-child(9) { animation-delay: 0.24s; }

#next-step{
background-color: #d90001!important;
}

    #next-step, #prev-step {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  font-family: 'Tomorrow', sans-serif;
  background-color: #ffffff;
  color: #111;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  transition: background-color 0.2s ease, color 0.2s ease;
}

#next-step:hover, #prev-step:hover {
  background-color: #f3f3f3;
}

#next-step:disabled, #prev-step:disabled {
  background-color: #ccc;
  color: #777;
  cursor: not-allowed;
  box-shadow: none;
}

    .step-title{
    text-transform: uppercase;
    }
    .country-suggestion {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #374151;
  color: white;
  font-size: 13px;
  font-family: 'Tomorrow', sans-serif;
  padding: 40px 10px;
  border: none;
  cursor: pointer;
  flex-direction: column;
  transition: background-color 0.2s ease;
}

.country-suggestion:hover {
  background-color: #1f2937;
}

    .club-suggestion {
  display: flex;
  align-items: center;
  background-color: #374151;
  color: white;
  font-size: 13px;
  font-family: 'Tomorrow', sans-serif;
  border: none;
  cursor: pointer;
  flex-direction: column;
  transition: background-color 0.2s ease;
}

.club-suggestion:hover {
  background-color: #1f2937;
}
.country-flag-icon {
  width: 50px;
    max-height: 30px;
}

    .club-icon {
  width: 114px;
}


.country-suggestions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 10px;
  justify-content: center;
}


.country-suggestion:nth-child(odd) {
  background-color: #24293d; /* dark background */
}

.country-suggestion:nth-child(even) {
  background-color: #383f49; /* slightly lighter background */
}


.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
    } 

.country-suggestion:hover {
  background-color: #1f2937;
}

    .club-suggestion:nth-child(odd) {
  background-color: #24293d; /* dark background */
}

.club-suggestion:nth-child(even) {
  background-color: #383f49; /* slightly lighter background */
}


.club-suggestion:hover {
  background-color: #1f2937;
}


.step-wrapper {
  width: 100%;
    min-width: 500px;
 
  background-color: #242833;
  overflow: hidden;
  box-shadow: 0 2px 5px rgba(0,0,0,0.15);
}

        @media (max-width: 768px) {
  .step-wrapper {
   min-width: 0px;
  }
}

    button:disabled,
.button:disabled {
  cursor: not-allowed !important;
}


.toggle-btn {
  width: 100%;
  background: none;
  color: white;
  padding: 12px;
  border: none;
  font-size: 14px;
  font-family: 'Tomorrow', sans-serif;
  text-align: left;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.toggle-btn .arrow {
  transition: transform 0.2s ease;
}

.toggle-panel {
  display: none;
  padding: 10px 12px 16px;
  animation: fadeIn 0.3s ease-in-out;
}

.toggle-panel input {
  margin-top: 8px;
  width: 100%;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 14px;
  font-family: 'Tomorrow', sans-serif;
  border: 1px solid #ccc;
  background-color: #f9fafb;
  color: #111827;
  text-align: center;
}

.toggle-panel input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
  outline: none;
}

.toggle-label {
  color: white;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  display: block;
}

.toggle-open .toggle-panel {
  display: block;
}

.toggle-open .arrow {
  transform: rotate(180deg);
}


#image-fade-overlay {
    display: none;
  z-index: 2; /* Between card-image (z=0) and card-content (z=1) */
  pointer-events: none;
  
}
    .image-fade-overlay{
    position: absolute;
  left: 0px;
    z-index: 2;
    bottom: -573px;
    width: 410px;
    }

    @media (max-width: 990px) {
  .image-fade-overlay {
    width: 100%;
    bottom: -392px;
}}



#card-content span[id^="card-"] {
  display: inline-block;
  text-align: center;
  font-family: 'cruyff_sans_numbers-medium';
}
#card-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  touch-action: none;

     /* ADD THIS BELOW */
  mask-image: url('https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Clipping-Mask.png');
  mask-size: contain;
  mask-repeat: no-repeat;
  mask-position: center;

  -webkit-mask-image: url('https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Clipping-Mask.png');
  -webkit-mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: top;

  overflow: hidden; /* optional if you want to guarantee hiding overflowed text */
}

#card-name {
  position: absolute;
    top: 327px;
  bottom: 92px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 22px;
  font-family: 'cruyff_sansbold';
}


/* Layer priorities */
#card-image {
  z-index: 0;
  position: relative;
}

#player-card-image-container {
  z-index: 1;
  position: absolute;
}

#card-content > p,
#card-content > div:not(#player-card-image-container) {
  z-index: 2;
  position: relative;
}
    .card-text-content {
  z-index: 2;
  position: relative;
}

.section-football-card-content-padding{
    min-height: 650px;
        background-image: url(https://cdn.shopify.com/s/files/1/0632/7094/4858/files/card-creator-background-extended.png?v=1746878377);
    flex-wrap: wrap;
    background-position: center -260px;
    background-repeat: no-repeat;
    background-color: #0e2236;
}
    .card-builder {
      display: flex;
    gap: 30px;
    justify-content: center;
    width: fit-content;
    align-items: flex-start;

}

    @media (max-width: 768px) {
  .section-football-card-content-padding {
    padding-top: 0 !important;
  }
}

 @media (max-width: 800px) {
  .pop-up-image {
    min-width: 0px!important;
    width: 70%!important;
  }
    .pop-up-box{
    flex-direction: column-reverse!important;
    }
    .pop-up-text{
    padding: 0px!important;
    }
}
   @media (max-width: 500px) {
  .club-icon {
    width: 90px;
  }

  .custom-upload-btn,.blue-buttons-card-creator{
  padding: 0!important;
  font-size: 15px!important;
  }

  .blue-buttons-card-creator{
  min-height: 27px;
  }

    label[for="brightness-slider"],
  label[for="contrast-slider"] {
    color: white;
    font-size: 15px;
    margin-right: 8px;
  }

  #pop-up-heading{
  font-size: 40px!important;
  margin-top: 5px;
  margin-bottom: 0px;
  }

  #pop-up-p{
  font-size: 12px!important;
  margin-top: 0px;
  }

  #add-stand-btn{
  font-size: 30px!important;
  }

}

.card-inputs{
z-index: 10;
}

   @media (max-width: 500px) {
  .toggle-btn{
    padding: 10px 0px !important;
    font-size: 13px !important;
  }
    .data-entry-styled{
    padding: 15px 0px !important;
    padding-left: 15px !important;
    }
    .step{
    min-height: 0px!important;}
}

   @media (max-width: 430px) {
  .country-suggestions {
    grid-template-columns: repeat(auto-fit, minmax(90px, 1fr));
  }
}

   @media (max-width: 768px) {
  
   .league-suggestion {
   padding: 0px 10px!important;
  }
   #custom-country-upload-btn{
   padding: 0px 0px!important;
    justify-content: center;
    gap: 0px;
   }
    #custom-league-upload-btn,#custom-club-upload-btn{
   padding: 0px 0px!important;
    justify-content: center;
   }
    .custom-span-upload{
    font-size: 15px!important;
    }
    .custom-upload-icon{
    max-width: 40px!important;
    }
    .country-flag-icon{
    width: 30px!important;
    }
    .club-icon{
    width: 50px!important;
    }
}

   @media (max-width: 400px) {
  #next-step, #prev-step {
    padding: 10px 10px;
  }
}

   @media (max-width: 510px) {
  #step-title-mobile {
   font-size: 1.4rem;
  }
   .club-icon{
    width: 40px!important;
    }
}

 @media (max-width: 490px) {
  .country-suggestion,.league-suggestion {
   padding: 10px 10px;
  }
   .country-flag-icon{
    width: 25px!important;
    }
}

  @media (max-width: 485px) {
  #step-title-mobile {
   font-size: 1.2rem;
  }
   .custom-upload-icon{
   max-width: 30px !important;
   }
   .custom-span-upload {
   font-size: 10px !important;
}
}



/* Stack vertically on small screens */
@media (max-width: 990px) {
  .card-builder {
    flex-direction: column;
    gap: 0px;
    align-items: center;
  }

  .card-inputs{
  order: 3;
  }

    #country-flag{
    top: 83.5%!important;
    bottom: 56.3px!important;
    right: 153px!important;
    width: 25px!important;
    }

    #league-logo{
    bottom: 52px!important;
    right: 126.1px!important;
    width: 25px!important;
    }

    #club-logo{
    bottom: 52px!important;
    right: 102px!important;
    width: 25px!important;
    }

    #card-name{
    top: 220px!important;
    font-size: 22px!important;
    }

    #card-rating{
    top: 39px!important;
    left: 22.6%!important;
    font-size: 36px!important;
    }

    #card-position{
    top: 100px!important;
    left: 22.6%!important;
    font-size: 18px!important;
    }

    .stat-span{
    font-size: 20px!important;
    }

    #stat-labels{
    top: 276px!important;
    font-size: 13px!important;
    gap: 12px!important;
    }


  

    #football-card-preview {
     order: -1;
     z-index: 0;
  max-width: 280px!important; /* Adjust based on your original card size */
  width: 100%;
  margin-top: -40px!important;
  margin-bottom: -25px!important;
  height: auto;
  text-align: center;
  margin: 0 auto;
}

  #download-btn {
    width: 100%;

    margin: 20px auto 0;
    display: block;
  }
}

.custom-upload-btn {
  border: none;
  margin-top: 5px;
  width: 55%;
  border-radius: 50px;
  padding: 14px;
  font-size: 20px;
  font-weight: bold;
  color: white;
  background-image: linear-gradient(to right, #7ebeff, #007eff);
  background-position: 0% 0%;
  transition: background-position 0.4s ease;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
}

.custom-upload-btn:hover {
  background-color: #7ebeff;
}

#progress-bar-mobile {
  display: none!important;
  z-index: 1;
}

@media (max-width: 990px) {

  #progress-bar-mobile {
  display: flex!important;
    order: 0;
    margin-top: 10px;
  }

  #football-card-preview {
    order: 1;
  }

  .step-container {
    order: 2;
  }
}

@media (max-width: 990px) {

  #progress-bar-desktop {
  display: none!important;

  }

}


.step-container{
width: 100%;
}


   /* Style for "Choose File" button container */
  input[type="file"] {
    padding: 6px 12px;
    border: 1px solid #ccc;
    background-color: #242833;
    font-family: 'cruyff_sansbold', sans-serif;
    cursor: pointer;
    width: 100%;
    color: #374151;
  }

  /* Hide default file input text */
  input[type="file"]::-webkit-file-upload-button {
    padding: 6px 12px;
    background-color: #242833;
    color: white;
    border: none;
    font-size: 14px;
    font-family: 'cruyff_sansbold', sans-serif;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  input[type="file"]::-webkit-file-upload-button:hover {
    background-color: #385789;
  }

  /* Firefox doesn't support ::-webkit-file-upload-button so just match the rest */
  input[type="file"]::file-selector-button {
    padding: 6px 12px;
    background-color: #24283;
    color: white;
    border: none;
    font-size: 14px;
    font-family: 'cruyff_sansbold', sans-serif;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  input[type="file"]::file-selector-button:hover {
    background-color: #385789;
  }

  /* Style for Download Button */
  #download-btn {
    padding: 10px 16px;
    background-color: #da0101; /* Tailwind green-500 */
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: bold;
    font-family: 'cruyff_sansbold', sans-serif;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;
  }

  #download-btn:hover {
    background-color: #990000; /* darker green */
  }

  #download-btn:active {
    transform: scale(0.98);
  }
  
   /* Remove number input arrows */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  
input[type="text"],
  input[type="number"],
  input[type="file"],
  select {
    font-family: 'cruyff_sansbold', sans-serif;
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ccc;
    font-size: 14px;
    background-color: #f9fafb;
    color: #111827;
    transition: border 0.2s, box-shadow 0.2s;
    box-sizing: border-box;
  }

  input[type="text"]:focus,
  input[type="number"]:focus,
  input[type="file"]:focus,
  select:focus {
    border-color: #3b82f6; /* Tailwind blue-500 */
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4); /* blue-500 focus ring */
    outline: none;
  }

  input::placeholder {
    color: #9ca3af; /* Tailwind gray-400 */
    font-weight: 400;
  }

  label {
    font-weight: 600;
    font-size: 15px;
    margin-bottom: 4px;
    display: block;
    color: #374151; /* Tailwind gray-700 */
  }
  
  input, select {
    font-family: 'Tomorrow';
    font-size: 15px;
  }

    #football-card-creator{
    padding: 0 16px;
    }

    #football-card-creator input::placeholder {
      text-align: center;
    }
    ::-webkit-input-placeholder { text-align: center; }
    ::-moz-placeholder { text-align: center; }
    :-ms-input-placeholder { text-align: center; }
    ::placeholder { text-align: center; }

    /* Make everything in the card non-selectable */
    #football-card-preview, #football-card-preview * {
      user-select: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
    }

    #corner-handles-wrapper {
  pointer-events: none; /* Ignore background clicks */
  position: absolute;
  z-index: 10; /* Behind image */
  border: 2px solid #4a82ff;
  opacity: 0;
}

    /* Four black corner squares for resizing */
    .corner-handle {
      position: absolute;
      width: 10px;
      height: 10px;
      cursor: nwse-resize;
      background: white;
      display: block !important;
    }
    .corner-top-left {
      top: -5px;
      left: -5px;
      cursor: nwse-resize;
    }
    .corner-top-right {
      top: -5px;
      right: -5px;
      cursor: nesw-resize;
    }
    .corner-bottom-left {
      bottom: -5px;
      left: -5px;
      cursor: nesw-resize;
    }
    .corner-bottom-right {
      bottom: -5px;
      right: -5px;
      cursor: nwse-resize;
    }

    /* Comment out or remove this to keep container hidden initially:
    #player-card-image-container {
      display: block !important;
    }
    */
  `;
  document.head.appendChild(style);


const stepIds = [
  "step-country",
  "step-club",
  "step-player",
  "step-image"
];

const steps = stepIds.map(id => document.getElementById(id));

let currentStep = 0;

const statLabels = {
  en: { position: "ST", PAC: "PAC", SHO: "SHO", PAS: "PAS", DRI: "DRI", DEF: "DEF", PHY: "PHY" },
  fr: { position: "BU", PAC: "VIT", SHO: "TIR", PAS: "PAS", DRI: "DRI", DEF: "DÉF", PHY: "PHY" },
  de: { position: "ST", PAC: "TEM", SHO: "SCH", PAS: "PAS", DRI: "DRI", DEF: "DEF", PHY: "PHY" },
  es: { position: "DC", PAC: "RIT", SHO: "TIR", PAS: "PAS", DRI: "REG", DEF: "DEF", PHY: "FIS" },
  it: { position: "ATT", PAC: "VEL", SHO: "TIR", PAS: "PAS", DRI: "DRI", DEF: "DIF", PHY: "FIS" },
  pt: { position: "ATA", PAC: "RAP", SHO: "FIN", PAS: "PAS", DRI: "DRI", DEF: "DEF", PHY: "FIS" },
  nl: { position: "SP", PAC: "SPD", SHO: "SCH", PAS: "PAS", DRI: "DRI", DEF: "VRD", PHY: "FYS" },
  pl: { position: "NAP", PAC: "SZY", SHO: "STR", PAS: "POD", DRI: "DRY", DEF: "OBR", PHY: "FIZ" },
  ru: { position: "ЦН", PAC: "СКР", SHO: "УДР", PAS: "ПАС", DRI: "ДРБ", DEF: "ЗАЩ", PHY: "ФИЗ" },
  tr: { position: "FS", PAC: "HIZ", SHO: "ŞUT", PAS: "PAS", DRI: "DRİ", DEF: "DEF", PHY: "FİZ" },
  ar: { position: "مها", PAC: "سرع", SHO: "تصو", PAS: "تمرير", DRI: "مرا", DEF: "دفا", PHY: "بدن" },
  sv: { position: "ANF", PAC: "FRT", SHO: "SKJ", PAS: "PAS", DRI: "DRI", DEF: "FÖR", PHY: "FYS" },
  no: { position: "ANG", PAC: "FRT", SHO: "SKY", PAS: "PAS", DRI: "DRI", DEF: "FORS", PHY: "FYS" },
  da: { position: "ANG", PAC: "FRT", SHO: "SKU", PAS: "AFL", DRI: "DRI", DEF: "FOR", PHY: "FYS" },
  cs: { position: "ÚT", PAC: "RYC", SHO: "STŘ", PAS: "PŘI", DRI: "DRI", DEF: "OBR", PHY: "FYS" },
};

  const countries = [
    { name: "Afghanistan", code: "af" },
    { name: "Åland Islands", code: "ax" },
    { name: "Albania", code: "al" },
    { name: "Algeria", code: "dz" },
    { name: "American Samoa", code: "as" },
    { name: "Andorra", code: "ad" },
    { name: "Angola", code: "ao" },
    { name: "Anguilla", code: "ai" },
    { name: "Antarctica", code: "aq" },
    { name: "Antigua and Barbuda", code: "ag" },
    { name: "Argentina", code: "ar" },
    { name: "Armenia", code: "am" },
    { name: "Aruba", code: "aw" },
    { name: "Australia", code: "au" },
    { name: "Austria", code: "at" },
    { name: "Azerbaijan", code: "az" },
    { name: "Bahamas", code: "bs" },
    { name: "Bahrain", code: "bh" },
    { name: "Bangladesh", code: "bd" },
    { name: "Barbados", code: "bb" },
    { name: "Belarus", code: "by" },
    { name: "Belgium", code: "be" },
    { name: "Belize", code: "bz" },
    { name: "Benin", code: "bj" },
    { name: "Bermuda", code: "bm" },
    { name: "Bhutan", code: "bt" },
    { name: "Bolivia", code: "bo" },
    { name: "Bosnia and Herzegovina", code: "ba" },
    { name: "Botswana", code: "bw" },
    { name: "Bouvet Island", code: "bv" },
    { name: "Brazil", code: "br" },
    { name: "British Indian Ocean Territory", code: "io" },
    { name: "Brunei Darussalam", code: "bn" },
    { name: "Bulgaria", code: "bg" },
    { name: "Burkina Faso", code: "bf" },
    { name: "Burundi", code: "bi" },
    { name: "Cambodia", code: "kh" },
    { name: "Cameroon", code: "cm" },
    { name: "Canada", code: "ca" },
    { name: "Cape Verde", code: "cv" },
    { name: "Cayman Islands", code: "ky" },
    { name: "Central African Republic", code: "cf" },
    { name: "Chad", code: "td" },
    { name: "Chile", code: "cl" },
    { name: "China", code: "cn" },
    { name: "Christmas Island", code: "cx" },
    { name: "Cocos (Keeling) Islands", code: "cc" },
    { name: "Colombia", code: "co" },
    { name: "Comoros", code: "km" },
    { name: "Congo", code: "cg" },
    { name: "Congo, Democratic Republic of the", code: "cd" },
    { name: "Cook Islands", code: "ck" },
    { name: "Costa Rica", code: "cr" },
    { name: "Côte d'Ivoire", code: "ci" },
    { name: "Croatia", code: "hr" },
    { name: "Cuba", code: "cu" },
    { name: "Curaçao", code: "cw" },
    { name: "Cyprus", code: "cy" },
    { name: "Czech Republic", code: "cz" },
    { name: "Denmark", code: "dk" },
    { name: "Djibouti", code: "dj" },
    { name: "Dominica", code: "dm" },
    { name: "Dominican Republic", code: "do" },
    { name: "Ecuador", code: "ec" },
    { name: "Egypt", code: "eg" },
    { name: "El Salvador", code: "sv" },
    { name: "England", code: "gb-eng" },
    { name: "Equatorial Guinea", code: "gq" },
    { name: "Eritrea", code: "er" },
    { name: "Estonia", code: "ee" },
    { name: "Eswatini", code: "sz" },
    { name: "Ethiopia", code: "et" },
    { name: "Falkland Islands (Malvinas)", code: "fk" },
    { name: "Faroe Islands", code: "fo" },
    { name: "Fiji", code: "fj" },
    { name: "Finland", code: "fi" },
    { name: "France", code: "fr" },
    { name: "French Guiana", code: "gf" },
    { name: "French Polynesia", code: "pf" },
    { name: "French Southern Territories", code: "tf" },
    { name: "Gabon", code: "ga" },
    { name: "Gambia", code: "gm" },
    { name: "Georgia", code: "ge" },
    { name: "Germany", code: "de" },
    { name: "Ghana", code: "gh" },
    { name: "Gibraltar", code: "gi" },
    { name: "Greece", code: "gr" },
    { name: "Greenland", code: "gl" },
    { name: "Grenada", code: "gd" },
    { name: "Guadeloupe", code: "gp" },
    { name: "Guam", code: "gu" },
    { name: "Guatemala", code: "gt" },
    { name: "Guernsey", code: "gg" },
    { name: "Guinea", code: "gn" },
    { name: "Guinea-Bissau", code: "gw" },
    { name: "Guyana", code: "gy" },
    { name: "Haiti", code: "ht" },
    { name: "Heard Island and McDonald Islands", code: "hm" },
    { name: "Holy See (Vatican City State)", code: "va" },
    { name: "Honduras", code: "hn" },
    { name: "Hong Kong", code: "hk" },
    { name: "Hungary", code: "hu" },
    { name: "Iceland", code: "is" },
    { name: "India", code: "in" },
    { name: "Indonesia", code: "id" },
    { name: "Iran", code: "ir" },
    { name: "Iraq", code: "iq" },
    { name: "Ireland", code: "ie" },
    { name: "Isle of Man", code: "im" },
    { name: "Israel", code: "il" },
    { name: "Italy", code: "it" },
    { name: "Jamaica", code: "jm" },
    { name: "Japan", code: "jp" },
    { name: "Jersey", code: "je" },
    { name: "Jordan", code: "jo" },
    { name: "Kazakhstan", code: "kz" },
    { name: "Kenya", code: "ke" },
    { name: "Kiribati", code: "ki" },
    { name: "Korea, Democratic People's Republic of", code: "kp" },
    { name: "South Korea", code: "kr" },
    { name: "Kuwait", code: "kw" },
    { name: "Kyrgyzstan", code: "kg" },
    { name: "Lao People's Democratic Republic", code: "la" },
    { name: "Latvia", code: "lv" },
    { name: "Lebanon", code: "lb" },
    { name: "Lesotho", code: "ls" },
    { name: "Liberia", code: "lr" },
    { name: "Libya", code: "ly" },
    { name: "Liechtenstein", code: "li" },
    { name: "Lithuania", code: "lt" },
    { name: "Luxembourg", code: "lu" },
    { name: "Macao", code: "mo" },
    { name: "Macedonia, the Former Yugoslav Republic of", code: "mk" },
    { name: "Madagascar", code: "mg" },
    { name: "Malawi", code: "mw" },
    { name: "Malaysia", code: "my" },
    { name: "Maldives", code: "mv" },
    { name: "Mali", code: "ml" },
    { name: "Malta", code: "mt" },
    { name: "Marshall Islands", code: "mh" },
    { name: "Martinique", code: "mq" },
    { name: "Mauritania", code: "mr" },
    { name: "Mauritius", code: "mu" },
    { name: "Mayotte", code: "yt" },
    { name: "Mexico", code: "mx" },
    { name: "Micronesia, Federated States of", code: "fm" },
    { name: "Moldova, Republic of", code: "md" },
    { name: "Monaco", code: "mc" },
    { name: "Mongolia", code: "mn" },
    { name: "Montenegro", code: "me" },
    { name: "Montserrat", code: "ms" },
    { name: "Morocco", code: "ma" },
    { name: "Mozambique", code: "mz" },
    { name: "Myanmar", code: "mm" },
    { name: "Namibia", code: "na" },
    { name: "Nauru", code: "nr" },
    { name: "Nepal", code: "np" },
    { name: "Netherlands", code: "nl" },
    { name: "New Caledonia", code: "nc" },
    { name: "New Zealand", code: "nz" },
    { name: "Nicaragua", code: "ni" },
    { name: "Niger", code: "ne" },
    { name: "Nigeria", code: "ng" },
    { name: "Niue", code: "nu" },
    { name: "Norfolk Island", code: "nf" },
    { name: "Northern Mariana Islands", code: "mp" },
    { name: "Norway", code: "no" },
    { name: "Oman", code: "om" },
    { name: "Pakistan", code: "pk" },
    { name: "Palau", code: "pw" },
    { name: "Palestine, State of", code: "ps" },
    { name: "Panama", code: "pa" },
    { name: "Papua New Guinea", code: "pg" },
    { name: "Paraguay", code: "py" },
    { name: "Peru", code: "pe" },
    { name: "Philippines", code: "ph" },
    { name: "Pitcairn", code: "pn" },
    { name: "Poland", code: "pl" },
    { name: "Portugal", code: "pt" },
    { name: "Puerto Rico", code: "pr" },
    { name: "Qatar", code: "qa" },
    { name: "Réunion", code: "re" },
    { name: "Romania", code: "ro" },
    { name: "Russian Federation", code: "ru" },
    { name: "Rwanda", code: "rw" },
    { name: "Saint Barthélemy", code: "bl" },
    { name: "Saint Helena, Ascension and Tristan da Cunha", code: "sh" },
    { name: "Saint Kitts and Nevis", code: "kn" },
    { name: "Saint Lucia", code: "lc" },
    { name: "Saint Martin (French part)", code: "mf" },
    { name: "Saint Pierre and Miquelon", code: "pm" },
    { name: "Saint Vincent and the Grenadines", code: "vc" },
    { name: "Samoa", code: "ws" },
    { name: "San Marino", code: "sm" },
    { name: "Sao Tome and Principe", code: "st" },
    { name: "Saudi Arabia", code: "sa" },
    { name: "Senegal", code: "sn" },
    { name: "Serbia", code: "rs" },
    { name: "Seychelles", code: "sc" },
    { name: "Sierra Leone", code: "sl" },
    { name: "Singapore", code: "sg" },
    { name: "Sint Maarten (Dutch part)", code: "sx" },
    { name: "Slovakia", code: "sk" },
    { name: "Slovenia", code: "si" },
    { name: "Solomon Islands", code: "sb" },
    { name: "Somalia", code: "so" },
    { name: "South Africa", code: "za" },
    { name: "South Georgia and the South Sandwich Islands", code: "gs" },
    { name: "South Sudan", code: "ss" },
    { name: "Spain", code: "es" },
    { name: "Sri Lanka", code: "lk" },
    { name: "Sudan", code: "sd" },
    { name: "Suriname", code: "sr" },
    { name: "Svalbard and Jan Mayen", code: "sj" },
    { name: "Sweden", code: "se" },
    { name: "Switzerland", code: "ch" },
    { name: "Syrian Arab Republic", code: "sy" },
    { name: "Taiwan, Province of China", code: "tw" },
    { name: "Tajikistan", code: "tj" },
    { name: "Tanzania, United Republic of", code: "tz" },
    { name: "Thailand", code: "th" },
    { name: "Timor-Leste", code: "tl" },
    { name: "Togo", code: "tg" },
    { name: "Tokelau", code: "tk" },
    { name: "Tonga", code: "to" },
    { name: "Trinidad and Tobago", code: "tt" },
    { name: "Tunisia", code: "tn" },
    { name: "Turkey", code: "tr" },
    { name: "Turkmenistan", code: "tm" },
    { name: "Turks and Caicos Islands", code: "tc" },
    { name: "Tuvalu", code: "tv" },
    { name: "Uganda", code: "ug" },
    { name: "Ukraine", code: "ua" },
    { name: "United Arab Emirates", code: "ae" },
    { name: "United Kingdom", code: "gb" },
    { name: "United States", code: "us" },
    { name: "United States Minor Outlying Islands", code: "um" },
    { name: "Uruguay", code: "uy" },
    { name: "Uzbekistan", code: "uz" },
    { name: "Vanuatu", code: "vu" },
    { name: "Venezuela, Bolivarian Republic of", code: "ve" },
    { name: "Vietnam", code: "vn" },
    { name: "Virgin Islands, British", code: "vg" },
    { name: "Virgin Islands, U.S.", code: "vi" },
    { name: "Wallis and Futuna", code: "wf" },
    { name: "Western Sahara", code: "eh" },
    { name: "Yemen", code: "ye" },
    { name: "Zambia", code: "zm" },
    { name: "Zimbabwe", code: "zw" }
  ];


const leagues = {
  "Bundesliga": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/bundesliga-fixed-logo.png?v=1745582243",
  "Ligue 1": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/ligue-1-fixed-logo.png?v=1745582243",
  "EPL (Purple)": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Premier-League-Logo-Purple.png?v=1745576646",
  "Eredivisie (White)": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Eredivisie-Logo-White.png?v=1745576646",
  "Eredivisie": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Eredivisie-Logo.png?v=1745576646",
  "EFL L1": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/EFL-League-one.png?v=1745576646",
  "EFL L2": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/EFL-League-Two.png?v=1745576646",
  "EFL": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/EFL-Championship.png?v=1745576646",
  "La Liga": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/La_Liga_Logo.png?v=1745576646",
  "EPL": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Premier_League_Logo.png?v=1745576646",
  "Serie A": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Serie-A-Logo.png?v=1745576646",
  "Scottish": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Scottish-League-Logo.png?v=1745576646"
};


  const clubs = {
  "Atletico Madrid": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Atletico_Madrid_Logo.png?v=1743834935",
  "AC Milan": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/ACM.png?v=1745308510",
"Inter Milan": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Inter-Logo.png?v=1745308510",
"Juventus": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Juventus-Logo.png?v=1745570562",
"Napoli": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Napoli_Logo.png?v=1745570610",
"Roma": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Roma-Logo.png?v=1745570610",
"PSG": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/PSG-Logo.png?v=1745308510",
"Southampton": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Southampton-Logo.png?v=1745572923",
"Ipswich Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Ipswich-Town-Logo.png?v=1745572923",
"Lecce": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Lecce-Logo.png?v=1745572924",
"OGC Nice": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/OGC-Nice-Logo.png?v=1745572924",
"Heracles": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Heracles-Logo.png?v=1745572924",
"AFC Wimbledon": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/AFC-Wimbeldon.png?v=1745572924",
"Vitoria": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Vitoria-Logo.png?v=1745572924",
"Como": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Como-Logo.png?v=1745572924",
"NAC Breda": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/NAC-logo.png?v=1745572924",
"Ajax": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Ajax-Logo.png?v=1745572924",
"FC Twente": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/FC-Twente-Logo.png?v=1745572924",
"Saint-Etienne": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Ettiene-Logo.png?v=1745572924",
"Leicester City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Leicester-City-Logo.png?v=1745572924",
"Genoa": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Genoa-Logo.png?v=1745572924",
"Harrogate Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Harrogate-Town.png?v=1745572924",
"Empoli": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Empoli-FC-Logo.png?v=1745572924",
"AVS Futebol": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/AVS-Futebol-Logo.png?v=1745572924",
"PSV": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/PSV-logo.png?v=1745572924",
"FC Utrecht": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Utrecht-Logo.png?v=1745572924",
"Montpellier": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Montpellier-Logo.png?v=1745572924",
"Le Havre": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Le-Havre-AC-Logo.png?v=1745572924",
"Gillingham": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Gillingham-FC.png?v=1745572924",
"Stade Rennais": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Rennais-Fc-Logo.png?v=1745572924",
"Toulouse": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Toulouse-Logo.png?v=1745572924",
"Famalicao": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Famalicao-Logo.png?v=1745572924",
"Cagliari": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Cagliari-Logo.png?v=1745572924",
"Angers": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Angers-Logo.png?v=1745572924",
"AZ Alkmaar": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/AZ-Alkamaar-Logo.png?v=1745572924",
"Heerenveen": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Heerenveen-logo.png?v=1745572924",
"Farense": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Farense-Logo.png?v=1745572924",
"Auxerre": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Auxerre-Logo.png?v=1745572924",
"Rangers": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Rangers-FC.png?v=1745572924",
"Moreirense": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Moreirense-Logo.png?v=1745572924",
"MK Dons": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/MK-Dons.png?v=1745572924",
"Salford City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Salford-City-FC.png?v=1745572924",
"Fortuna Sittard": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Fortuna-Sittard-Logo.png?v=1745572924",
"Cheltenham Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Cheltenham-Town.png?v=1745572924",
"Port Vale": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Port-Vale-FC.png?v=1745572924",
"Feyenoord": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Feyenoord-Logo.png?v=1745572924",
"St Mirren": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/St-Mirren-FC.png?v=1745572924",
"St Johnstone": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/St-Johnstone-FC.png?v=1745572925",
"Swindon Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Swindon-Town-FC.png?v=1745572925",
"Newport County": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Newport-County-FC.png?v=1745572925",
"Barrow": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Barrow-FC.png?v=1745572924",
"Go Ahead Eagles": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Go-Ahead-Eagles-Logo.png?v=1745572925",
"Aberdeen": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Aberdeen.png?v=1745572924",
"Estrela": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Simbolo-Estrela-Logo.png?v=1745572925",
"Bologna": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bologna-FC-Logo.png?v=1745572925",
"Estoril Praia": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Estoril-Praia-Logo.png?v=1745572924",
"Sparta Rotterdam": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Sparta-Rotterdam-Logo.png?v=1745572924",
"PEC Zwolle": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/PEC-Zwolle-Logo.png?v=1745572924",
"Chesterfield": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Chesterfield-FC.png?v=1745572925",
"NEC Nijmegen": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/NEC-Nijmegen-Logo.png?v=1745572924",
"Nantes": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Nantes-Logo.png?v=1745572925",
"Atalanta": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Atalanta-FC.png?v=1745572925",
"Willem II": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/FC-Willem-Logo.png?v=1745572925",
"Grimsby Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Grimsby-Town.png?v=1745572925",
"Tranmere Rovers": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Tranmere.png?v=1745572925",
"FC Groningen": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Groningen-Logo.png?v=1745572925",
"Notts County": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Notts-County.png?v=1745572925",
"Celtic": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Celtic-FC.png?v=1745572925",
"Strasbourg": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Strasbourgh-FC-Logo.png?v=1745572924",
"Boavista": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Boavista-FC-logo.png?v=1745572925",
"Almere City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Almere-City-Logo.png?v=1745572925",
"Fleetwood Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Fleetwood-Town.png?v=1745572925",
"Parma": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Parma-Calcio-Logo.png?v=1745572925",
"Bradford City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bradford-City.png?v=1745572925",
"Walsall": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Walsall-FC.png?v=1745572925",
"Stade Reims": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Stade_Reims_Logo.png?v=1745572925",
"Doncaster Rovers": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Doncaster-Rovers-FC.png?v=1745572925",
"Gil Vicente": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Gil_Vicente_FC.png?v=1745572925",
"Morecambe": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Morecambe-FC.png?v=1745572925",
"Fiorentina": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Fiorentina-logo.png?v=1745572925",
"Nacional": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Nacional-Logo.png?v=1745572925",
"Venezia": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Venezia-FC-Logo.png?v=1745572925",
"Accrington Stanley": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Accrington-Stanley.png?v=1745572925",
"Ross County": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Ross-County-Logo.png?v=1745572925",
"Dundee United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Dundee-United.png?v=1745572925",
"Dundee": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Dundee-FC-Logo.png?v=1745572925",
"Lens": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Lens-Logo.png?v=1745572925",
"Crewe Alexandra": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Crewe-Alexandra.png?v=1745572925",
"Arouca": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Arouca-Logo.png?v=1745572925",
"Brest": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Brest_Logo.png?v=1745572925",
"Colchester United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Colchester-United-FC.png?v=1745572925",
"Hearts": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Hearts-FC.png?v=1745572925",
"Hellas Verona": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Hellas_Verona_Logo.png?v=1745572925",
"Waalwijk": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Waalwijk-Logo.png?v=1745572925",
"Benfica": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Benfica_Logo.png?v=1745572925",
"Torino": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Torino_FC.png?v=1745572925",
"Braga": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Braga_Logo.png?v=1745572925",
"Rio Ave": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Rio_Ave_Logo.png?v=1745572925",
"Lazio": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Lazio_png.png?v=1745572925",
"Porto": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Porto_Logo.png?v=1745572925",
"Santa Clara": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Santa_Clara_Logo.png?v=1745572925",
"Monza": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Monza_Logo.png?v=1745572925",
"Udinese": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Udinese_Logo.png?v=1745572925",
"Bromley": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bromley_FC.png?v=1745572925",
"Kilmarnock": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Kilmarnock_Logo.png?v=1745572925",
"Hibernian": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Hibernian.png?v=1745572925",
"Sporting": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Sporting_Logo.png?v=1745572925",
"Getafe": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Getafe_Logo.png?v=1745572925",
"Carlisle United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Carlisle_United_FC.png?v=1745572925",
"Motherwell": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Motherwell_FC.png?v=1745572925",
"Marseille": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Marseille-Logo.png?v=1745570708",
"Lyon": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Lyon-Logo.png?v=1745570708",
"Monaco": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/AS-Monaco-Logo.png?v=1745570707",
"Lille": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Lille-Logo.png?v=1745570707",
"Wolfsburg": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Wolfsburg-Logo.png?v=1745571451",
"Bristol City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bristol-City-Logo_d62f19b4-970b-4c0a-abbf-152db3e40fba.png?v=1745571494",
"Derby County": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Derby-County-Logo_89de10c5-540f-44d3-8cb8-b187294c8b2c.png?v=1745571494",
"Cardiff City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Cardiff-Logo_37148f12-f95c-467f-9bd8-9a961010c71d.png?v=1745571494",
"Hull City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Hull-City_c20bb6a3-660c-4c4a-b867-e90f7f710bed.png?v=1745571494",
"Middlesbrough": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Middlesbrough-Logo_0b564b57-6c61-4f5c-a714-c142d31a4429.png?v=1745571495",
"Millwall": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Milwall_Logo_643307be-4b62-40c1-b95e-4163b62a6ee5.png?v=1745571495",
"Coventry City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Coventry_Logo_a5210bcf-082a-4fe7-a0b5-f18bfb160a73.png?v=1745571495",
"Norwich City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Norwich_city_logo_11a80c57-d855-4afc-8478-1c5acd02df4c.png?v=1745571495",
"Leeds United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Leeds_logo_9acbaf52-db8b-4f17-9960-140086492484.png?v=1745571495",
"Blackburn Rovers": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Blackburn_Logo_675e1649-c84d-4ca8-ae74-4f6c9ff2eb01.png?v=1745571495",
"Swansea City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Swansea-Logo_6f1e7f7d-94dc-4611-ae00-e92b68833925.png?v=1745571505",
"QPR": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/QPR-Logo_68b2832f-490f-4647-839c-9f15e0bd0b1a.png?v=1745571505",
"Plymouth Argyle": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Plymouth-Argyle-Logo_0aeea711-ebc4-472e-9967-5a9ad6d01d7e.png?v=1745571505",
"Stoke City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Stoke-City-Logo_89818518-8ede-4eef-97a4-f8e79b5c7591.png?v=1745571505",
"Watford": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Watford-Logo_f84cf2e4-a409-4f8f-98ff-5ea391d2ed02.png?v=1745571505",
"Portsmouth": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Portsmouth-Logo_3ac6aabb-76c8-45e3-82a0-cc17590a5967.png?v=1745571505",
"West Bromwich Albion": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/West-bromwich-albion-WBA-Logo_19d1384a-de98-4bb6-a3ba-8bd607af55eb.png?v=1745571505",
"Preston North End": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Preston-Logo_a5172f60-5988-404f-a580-7e55a6151cca.png?v=1745571505",
"Sheffield Wednesday": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Sheffield_wednesday_logo_61767215-83e7-4ddd-951b-a73ef0b919c2.png?v=1745571505",
"Sunderland": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Sunderland_Logo_9d0b2f06-7407-4117-9675-533caef32f97.png?v=1745571505",
"Oxford United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Oxford_United_Logo_0b135d90-d000-4c8a-963b-a335ff438e88.png?v=1745571505",
  "Las Palmas": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Las_Palmas_Logo.png?v=1743834936",
  "Alaves": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Alaves_Logo.png?v=1743834935",
  "Osasuna": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Osasuna_Logo.png?v=1743834935",
  "Villarreal": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Villrreal_Logo.png?v=1743834935",
  "Sevilla": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Sevilla_FC_logo.png?v=1743834935",
  "Celta Vigo": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Celta_Logo.png?v=1743834935",
  "Real Betis": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Betis_Logo.png?v=1743834935",
  "Real Sociedad": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Sociedad_Logo.png?v=1743834935",
  "Mallorca": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Mallorca_Logo.png?v=1743834935",
  "Valencia": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Valencia-Logo.png?v=1743834935",
  "Barcelona": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/barcelona-logo.png?v=1745308510",
  "Real Madrid": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Real-Madrid.png?v=1745308510",
  "Girona": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Girona-Logo.png?v=1743834934",
  "Valladolid": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Valladolid-Logo.png?v=1743834934",
  "Espanyol": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Espanyol-Logo.png?v=1743834934",
  "Athletic Bilbao": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Athletic-Bilbao-logo.png?v=1743834934",
  "Leganes": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Leganes-Logo.png?v=1743834934",
  "Rayo Vallecano": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Rayo-Vallecano-Logo.png?v=1743834934",
  "Brentford": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Brentford-logo.png?v=1743828209",
  "Bournemouth": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/AFC-Bournemouth-logo.png?v=1743828209",
  "Man City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/City-Logo.png?v=1743828209",
  "Luton Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Luton-Town-logo-PNG.png?v=1743828209",
  "West Ham": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/West-ham-loog.png?v=1743828209",
  "Aston Villa": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Aston-Villa-Logo.png?v=1743828209",
  "Brighton": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Brighton-Logo.png?v=1743828209",
  "Chelsea": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Chelsea-Logo.png?v=1743828209",
  "Crystal Palace": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Crystal-Palace-Logo.png?v=1743828209",
  "Wolves": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Wolves-Logo.png?v=1743828209",
  "Fulham": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Fulham-log.png?v=1743828209",
  "Arsenal": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Arsenal-Logo_36656d57-e3f0-4300-8fbc-665be230e8ee.png?v=1745308510",
  "Liverpool": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Liverpool-logo.png?v=1743828209",
  "Man United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Man-Utd-Logo.png?v=1743828208",
  "Sheffield United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Sheffield-United-Logo.png?v=1743828208",
  "Everton": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Everton-Logo.png?v=1743828208",
  "Nottingham Forest": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Nottingham-Logo.png?v=1743828208",
  "Burnley": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Burnley-Logo.png?v=1743828208",
  "Newcastle United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Newcastle-United-Logo.png?v=1743828208",
  "Tottenham": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Tottenham-Logo.png?v=1743828207",
  "Birmingham": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Birmingham-Logo.png?v=1743919757",
"Cambridge United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Cambridge-United-Logo.png?v=1743919757",
"Mansfield Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Mansfield-Town-Logo.png?v=1743919758",
"Wigan Athletic": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Wigan-Athletic-Logo.png?v=1743919758",
"Crawley Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Crawley-Town-Logo.png?v=1743919758",
"Exeter City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Exeter-City-Logo.png?v=1743919758",
"Burton Albion": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Brewers-FC-Logo.png?v=1743919758",
"Stockport": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Stockport-Logo.png?v=1743919758",
"Reading": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Reading-logo.png?v=1743919758",
"Bolton Wanderers": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bolton-Wanderers-Logo.png?v=1743919759",
"Huddersfield Town": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Huddersfield-Town-Logo.png?v=1743919759",
"Bristol Rovers": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bristol-Rovers-Logo.png?v=1743919758",
"Northampton": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Northampton-FC-Logo.png?v=1743919759",
"Wrexham": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Wrexham-FC-Logo.png?v=1743919759",
"Shrewsbury": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Shewsbury-Logo.png?v=1743919759",
"Wycombe": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Wycome_Logo.png?v=1743919759",
"Charlton Athletic": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Charlton_Athletic_Logo.png?v=1743919759",
"Peterborough": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Peterborough_FC_Logo.png?v=1743919759",
"Rotherham United": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Rotherham-United-Logo.png?v=1743919759",
"Lincoln City": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Lincoln_City_Logo.png?v=1743919759",
"Leyton Orient": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Leyton_Orient_Logo.png?v=1743919759",
"Barnsley": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Barnsley_FC_Logo.png?v=1743919759",
"Blackpool": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Blackpool_FC_Logo.png?v=1743919759",
"Stevenage": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Stevenage_FC_logo.png?v=1743919759",
"Borussia Dortmund": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/BVB-Dortmund-Logo.png?v=1743980947",
"Bayern Munich": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bayern.png?v=1745308511",
"Eintracht Frankfurt": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Frankfurt-Logo.png?v=1743980948",
"Werder Bremen": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Werder-Bremen-logo.png?v=1743980948",
"Bochum": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Bochum-Logo.png?v=1743980948",
"Freiburg": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Freiburg-Logo.png?v=1743980948",
"Hoffenheim": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Hoffeinheim-Logo.png?v=1743980948",
"Bayer Leverkusen": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Leverkusen-Logo.png?v=1743980948",
"Stuttgart": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Stuttgart-Logo.png?v=1743980948",
"Heidenheim": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Heidenheim-Logo.png?v=1743980948",
"Holstein Kiel": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Holstein-Logo.png?v=1743980948",
"Borussia Mönchengladbach": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Borussia-Monchengladbach-Logo.png?v=1743980948",
"FC Augsburg": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/FC-Augsburg-Logo.png?v=1743980948",
"St. Pauli": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/St-Pauli-Logo.png?v=1743980948",
"RB Leipzig": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Leipzig_Logo.png?v=1743980948",
"Mainz": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Mainz_Logo.png?v=1743980949",
"Union Berlin": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Union_Berlin_Logo.png?v=1743980948",
"Werder Bremen (Alt)": "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Werder-Bremen-logo_a2137f63-5435-494b-86d0-59e89b4a58b0.png?v=1743980981"
};

   // Build datalist options for country input
  let countryOptions = "";
  countries.forEach(function(country) {
    countryOptions += `<option value="${country.name}"></option>`;
  });

// Preload club logos
Object.values(clubs).forEach(src => {
  const img = new Image();
  img.src = src;
});



let clubOptions = "";
Object.keys(clubs).forEach(function(clubName) {
  clubOptions += `<option value="${clubName}"></option>`;
});




  // Set up the main card HTML including the download button
  const container = document.getElementById("football-card-creator");
  if (!container) return;
  container.innerHTML = `
  <div class="card-builder">
 

<div id="progress-bar-mobile" style="display: flex; align-items: center; gap: 10px; font-family: 'cruyff_condensed_medium'; color: white;">
        <span id="step-title-mobile" class="step-title" style="font-weight: bold;line-height: normal;">Choose your nation</span>
        
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div class="step-indicator" data-step="0" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: white; color: black; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">1</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="1" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">2</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="2" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">3</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="3" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">4</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="4" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">5</div>
        </div>
        <div style="display: flex; gap: 10px;">
          <button id="prev-step">Back</button>
          <button id="next-step">Next</button>
        </div>
      </div>

      <div class="card-inputs">

      <!-- Progress Bar -->
      <div id="progress-bar-desktop" style="margin-bottom: 20px; display: flex; align-items: center; gap: 10px; font-family: 'cruyff_condensed_medium'; color: white;">
        <span id="step-title-desktop" class="step-title" style="font-weight: bold;">Choose your nation</span>
        
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div class="step-indicator" data-step="0" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: white; color: black; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">1</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="1" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">2</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="2" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">3</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="3" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">4</div>
          <div style="width: 24px; height: 2px; background-color: white;"></div>
          <div class="step-indicator" data-step="4" style="width: 22px; height: 22px; border-radius: 50%; border: 2px solid white; background-color: transparent; color: white; display: flex; align-items: center; justify-content: center; font-size: 12px; font-weight: bold;margin: 0px 4px">5</div>
        </div>
        <div style="display: flex; gap: 10px;">
          <button id="prev-step">Back</button>
          <button id="next-step">Next</button>
        </div>
      </div>

      <div class="step-container">

        <div class="step-wrapper">
          <div class="step" id="step-country">
            <div id="country-select-panel">
            <!-- Tab buttons -->
            <div style="display: flex; gap: 6px; margin-bottom: 10px; flex-wrap: nowrap; overflow-x: auto;">
              <button id="popular-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #111827;">Popular</button>
              <button id="europe-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Europe</button>
              <button id="americas-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Americas</button>
              <button id="africa-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Africa</button>
              <button id="asia-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Asia</button>
            </div>
            <!-- Empty placeholders for JS to fill -->
            <div id="country-suggestions-popular" class="country-suggestions"></div>
            <div id="country-suggestions-europe" class="country-suggestions" style="display: none;"></div>
            <div id="country-suggestions-americas" class="country-suggestions" style="display: none;"></div>
            <div id="country-suggestions-africa" class="country-suggestions" style="display: none;"></div>
            <div id="country-suggestions-asia" class="country-suggestions" style="display: none;"></div>
            <input type="file" id="upload-country-flag" accept="image/*" style="display: none;">
            <input type="text" id="country-input" placeholder="Type a country" >
          </div>
        </div>

        <div class="step" id="step-league" style="display: none;">
          <div id="league-select-panel">
            <!-- League Tabs -->
            <div style="display: flex; gap: 6px; margin-bottom: 10px; flex-wrap: nowrap; overflow-x: auto;">
              <button id="popular-leagues-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #111827;">Popular</button>
              <button id="english-leagues-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">English</button>
            </div>

            <!-- League suggestions -->
            <div id="league-suggestions-popular" class="country-suggestions"></div>
            <div id="league-suggestions-english" class="country-suggestions" style="display: none;"></div>

            <input type="text" id="league-input" placeholder="Type a league" style="padding: 8px 12px; width: 100%; text-align: center;">
          </div>
        </div>


        <div class="step" id="step-club" style="display: none;">
          <div class="step-wrapper">
            <div id="club-select-panel">
            <!-- League Tabs -->
              <div style="display: flex; gap: 6px; margin-bottom: 10px; flex-wrap: nowrap; overflow-x: auto;">
                <button id="popular-clubs-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #111827;">Popular</button>
                <button id="premier-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Prem</button>
                <button id="laliga-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">LaLiga</button>
                <button id="seriea-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Serie A</button>
                <button id="ligue1-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Ligue 1</button>
                <button id="bundesliga-tab" class="toggle-btn" style="font-size: 12px; padding: 8px; background-color: #374151;">Bundesliga</button>
                <input type="file" id="upload-club-logo" accept="image/*" style="display: none;">

              </div>

              <!-- League suggestion containers -->
              <div id="club-suggestions-laliga" class="country-suggestions" style="display: none;"></div>
              <div id="club-suggestions-premier" class="country-suggestions" style="display: none;"></div>
              <div id="club-suggestions-seriea" class="country-suggestions" style="display: none;"></div>
              <div id="club-suggestions-ligue1" class="country-suggestions" style="display: none;"></div>
              <div id="club-suggestions-bundesliga" class="country-suggestions" style="display: none;"></div>
              <div id="club-suggestions-popular-clubs" class="country-suggestions"></div>
              <input type="file" id="upload-league-logo" accept="image/*" style="display: none;">
              <input type="text" id="club-input" placeholder="Type a club" list="club-list" margin-bottom: 10px; padding: 5px; width: 100%; text-align: center;">
            </div>
          </div>
        </div>

        <div class="step" id="step-player" style="display: none;min-height: 500px;">
          <input class="data-entry-styled" type="text" id="player-name" placeholder="Player Name">
          <div style="display: flex;">
            <input style="background-color: #383f49" class="data-entry-styled" type="number" id="player-rating" placeholder="99" min="1" max="99">
            <input style="background-color: #24293d;border-top: 2px solid #383f49 !important;" class="data-entry-styled" type="text" id="player-position" placeholder="ST">
          </div>
          <div style="display: flex;">
            <input class="data-entry-styled" type="number" id="player-pace" placeholder="PAC" min="1" max="99" style="padding: 5px 0; width: 100%;">
            <input class="data-entry-styled" type="number" id="player-dribbling" placeholder="DRI" min="1" max="99" style="padding: 5px 0; width: 100%;">
          </div>
          <div style="display: flex;">
            <input style="background-color: #383f49;" class="data-entry-styled" type="number" id="player-shooting" placeholder="SHO" min="1" max="99" style="padding: 5px 0; width: 100%;">
            <input style="background-color: #24293d;" class="data-entry-styled" type="number" id="player-defending" placeholder="DEF" min="1" max="99" style="padding: 5px 0; width: 100%;">
          </div>
          <div style="display: flex;">
            <input class="data-entry-styled" type="number" id="player-passing" placeholder="PAS" min="1" max="99" style="padding: 5px 0; width: 100%;">       
            <input class="data-entry-styled" type="number" id="player-physical" placeholder="PHY" min="1" max="99" style="padding: 5px 0; width: 100%;">
          </div>
          <div class="language-select-wrapper" >
            <button id="toggle-language-btn" class="toggle-btn" style="width: 100%; padding: 20px!important; background-color: #111827; color: white;min-height: 64px;font-size: 20px;font-family:'cruyff_sansbold', sans-serif">Select Language
              <span class="arrow">&#9662;</span>
            </button>
            <div id="language-select-panel" class="toggle-panel" style="display: none; margin-top: 10px; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 15px;">
          </div>
        </div>

        </div>

  

        <div class="step" id="step-image" style="display: none;min-height: 500px;max-width:500px;">
          <label style="color: white;padding-top: 10px;">Upload Player Image</label>
<label for="player-image" class="custom-upload-btn">Choose File</label>
<input type="file" id="player-image" accept="image/*" style="display: none;">
<p id="file-name" style="color:white; font-size:14px; margin-top:8px;"></p>

          <div style="text-align:center; margin-bottom: 20px;">
            <label for="brightness-slider">Fade Brightness</label>
            <input type="range" id="brightness-slider" min="0.5" max="2" step="0.01" value="1.2">
            <label for="contrast-slider" style="margin-left: 20px;">Fade Contrast</label>
            <input type="range" id="contrast-slider" min="0.5" max="2" step="0.01" value="1.1">
            <button class="blue-buttons-card-creator" id="reset-image-btn">Reset image</button>
            <button class="blue-buttons-card-creator" id="remove-bg-btn">Remove Background</button>
             <label id="background-remover-message" for="contrast-slider">If the background removal isn’t accurate, upload your image and our team will remove the background manually.</label>
   

          </div>
        </div>
      </div>
    </div>
    </div>
    
<!-- Add outside of card-content -->
<div id="corner-handles-wrapper" style="position: absolute; top: 0; left: 0;">
  <div class="corner-handle corner-top-left"></div>
  <div class="corner-handle corner-top-right"></div>
  <div class="corner-handle corner-bottom-left"></div>
  <div class="corner-handle corner-bottom-right"></div>
</div>

  <div id="football-card-preview" style="position: relative; max-width: 410px;height: auto; text-align: center;">
    <img id="card-image" src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/${filename}" alt="Card Background" style="width: 100%; position: relative;">
    



    <div id="card-content" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; color: #2d2410; font-weight: bold; flex-direction: column; align-items: center; justify-content: center;">
      <div id="image-fade-overlay">  <img id="fade-adjusting" class="image-fade-overlay" src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/${filename}"></div>
        <img id="country-flag" alt="Country Flag" src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/new-unknown-flag.png?v=1745591818" style="z-index: 3;position: absolute; top: 83%;transform: translateY(-50%);bottom: 56.3px; right: 228px; width: 35px; display: block;">
        <img id="league-logo" alt="League Logo" src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknownleagueScottish-League-Logo.png?v=1745576570"
         style="position: absolute;z-index: 3; bottom: 80px; right: 185.9px; width: 35px; display: block;">
        <img id="club-logo" alt="Club Logo" src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknown-club-badge.png?v=1743862041" style="z-index: 3;position: absolute; bottom: 81px; right: 149px; width: 32px; display: block;">
        <p id="card-rating" style="position: absolute; top: 47px; left: 22.1%;transform: translateX(-50%); font-size: 57px; font-family: 'cruyff_sans_numbers-bold'!important;">99</p>
        <p id="card-position" style="position: absolute; top: 145px; left: 22.3%;transform: translateX(-50%); font-size: 26px; font-family: 'cruyff_condensed_medium'!important;">ST</p>
        <p id="card-name" style="position: absolute; bottom: 92px; font-size: 31px; font-family: 'cruyff_sansbold'!important;">Player Name</p>

        <div id="player-card-image-container" style="position: absolute; top: 28%; left: 40%; transform: translate(-50%, -50%);width: 100px; height: 100px; display: none;">
          <img id="player-card-image" src="" alt="Player Image" style="width: 100%; height: 100%;">
        </div>

        <div class="card-text-content">
          <div  id="stat-labels" style="position: absolute; top: 403px; left: 50%; transform: translateX(-50%); font-size: 21px; display: flex; gap: 17px; font-weight:200; font-family: 'cruyff_condensed_medium'; line-height: 1.2;">
            <div class="stat-block">PAC<br><span class="stat-span" id="card-pace" style="font-size: 25px;font-weight:800;font-family: 'cruyff_sans_numbers-medium';">99</span></div>
            <div class="stat-block">SHO<br><span class="stat-span" id="card-shooting" style="font-size: 25px;font-weight:800;font-family: 'cruyff_sans_numbers-medium';">99</span></div>
            <div class="stat-block">PAS<br><span class="stat-span" id="card-passing" style="font-size: 25px;font-weight:800;font-family: 'cruyff_sans_numbers-medium';">99</span></div>
            <div class="stat-block">DRI<br><span class="stat-span" id="card-dribbling" style="font-size: 25px;font-weight:800;font-family: 'cruyff_sans_numbers-medium';">99</span></div>
            <div class="stat-block">DEF<br><span class="stat-span" id="card-defending" style="font-size: 25px;font-weight:800;font-family: 'cruyff_sans_numbers-medium';">99</span></div>
            <div class="stat-block">PHY<br><span class="stat-span" id="card-physical" style="font-size: 25px;font-weight:800;font-family: 'cruyff_sans_numbers-medium';">99</span></div>
          </div>
        </div> 
      </div>
    </div>
  </div>

  <div id="stand-popup" style=" 
  display:none; position:fixed; top:0; left:0; width:100%; height:100%;
  background-color:rgba(0,0,0,0.6); z-index:1000; justify-content:center; align-items:center;">
  <div class="pop-up-box" style="
    background:#ff0000; color:#ffffff; padding:20px; border-radius:10px; max-width:900px; width:90%;
    display:flex; flex-wrap:wrap; align-items:center; justify-content:space-between;">

    <!-- Text and buttons on the left -->
    <div class="pop-up-text" style="flex:1; min-width:280px; padding-right:20px;">
      <h2 id="pop-up-heading" style="font-size: 50px; font-weight:1000; margin-bottom:10px;">
        <span style="color:#000;">ADD-ON</span><br>
        <span style="color:#fff;">CARD STAND</span>
      </h2>
      <p id="pop-up-p" style="font-size:16px;">An Acrylic stand to provide support for your card and place it wherever you would like</p>

<div id="card-loading-spinner" style="padding-bottom: 10px;">
    <span class="loader"></span>
    </div>


      <div style="margin-bottom:10px;">
        <button id="add-stand-btn" style="
          font-size:50px; font-weight:bold; padding:16px 36px; background:#000000; color:#ffffff;text-transform: uppercase;
          border:none; border-radius:8px; cursor:pointer;">Buy $4.99</button>
      </div>

      <div>
        <button id="skip-stand-btn" style="
          font-size:25px;text-transform: uppercase; background:none; color:#ffffff; border:none; text-decoration:none;font-family: Sora !important;
    font-weight: 500;
          cursor:pointer;">Skip</button>
      </div>
    </div>

    <!-- Image on the right -->
    <div class="pop-up-image" style="flex:1; min-width:280px; display:flex; justify-content:center;">
      <img src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/Stand.png?v=1748967484" alt="Card Stand Preview" style="
        max-width:100%; width:100%; height:auto; border-radius:10px; box-shadow:0 4px 10px rgba(0,0,0,0.3);" />
    </div>

  </div>
</div>



    <!-- Download button 
    <button id="download-btn" style="margin-top: 10px;">Download Card</button>
    -->
  `;

requestAnimationFrame(() => {
  document.getElementById("card-image").src = `https://cdn.shopify.com/s/files/1/0632/7094/4858/files/${filename}`;
  document.getElementById("fade-adjusting").src =
  `https://cdn.shopify.com/s/files/1/0632/7094/4858/files/${
    filename.replace(/\.png$/, "_fade.png")
  }`;

});

window.customLeagueBase64 = "";
window.customFlagBase64 = "";
window.customClubBase64 = "";


// Wait until DOM updates fully
requestAnimationFrame(() => {
  bindAllUIEventsAfterInjection();  // call your input binding functions *here*
});

let originalUploadedBase64 = ""; 


updateLeagueLogoBasedOnStyle();


function positionCornerHandles() {
  const container = document.getElementById('player-card-image-container');
  const handlesWrapper = document.getElementById('corner-handles-wrapper');

  if (!container || !handlesWrapper) return;

  const containerRect = container.getBoundingClientRect();
  const parentRect = handlesWrapper.offsetParent.getBoundingClientRect(); // shared parent

  const offsetX = containerRect.left - parentRect.left;
  const offsetY = containerRect.top - parentRect.top;

  handlesWrapper.style.left = `${offsetX}px`;
  handlesWrapper.style.top = `${offsetY}px`;
  handlesWrapper.style.width = `${containerRect.width}px`;
  handlesWrapper.style.height = `${containerRect.height}px`;

  const size = 10;

  handlesWrapper.querySelector('.corner-top-left').style.cssText =
    `position:absolute; width:${size}px; height:${size}px; left:-${size/2}px; top:-${size/2}px;`;

  handlesWrapper.querySelector('.corner-top-right').style.cssText =
    `position:absolute; width:${size}px; height:${size}px; left:${containerRect.width - size/2}px; top:-${size/2}px;`;

  handlesWrapper.querySelector('.corner-bottom-left').style.cssText =
    `position:absolute; width:${size}px; height:${size}px; left:-${size/2}px; top:${containerRect.height - size/2}px;`;

  handlesWrapper.querySelector('.corner-bottom-right').style.cssText =
    `position:absolute; width:${size}px; height:${size}px; left:${containerRect.width - size/2}px; top:${containerRect.height - size/2}px;`;
}




function bindAllUIEventsAfterInjection() {
  const countryInput = document.getElementById("country-input");
  const countryFlag = document.getElementById("country-flag");
  const nextBtns = document.querySelectorAll("#next-step");
const prevBtns = document.querySelectorAll("#prev-step");
  const steps = document.querySelectorAll(".step");

if (!window.hasBoundStepListeners) {
  nextBtns.forEach(btn => btn.addEventListener("click", handleNextStep));
  prevBtns.forEach(btn => btn.addEventListener("click", () => {
    if (currentStep > 0) {
      currentStep--;
      showStep(currentStep);
    }
  }));
  window.hasBoundStepListeners = true;
}


  
console.log("Steps found:", steps.length);



  const stepTitles = [
  "Choose your nation",
  "Choose your league",
  "Choose your club",
  "Enter player details",
  "Upload image"
];




// Bind brightness and contrast sliders
const brightnessSlider = document.getElementById('brightness-slider');
const contrastSlider = document.getElementById('contrast-slider');
const fadeadjustingImage = document.getElementById('fade-adjusting');

if (brightnessSlider && contrastSlider && fadeadjustingImage) {
  function updateImageFilter() {
    const brightness = brightnessSlider.value;
    const contrast = contrastSlider.value;
    fadeadjustingImage.style.filter = `brightness(${brightness}) contrast(${contrast})`;
  }

  brightnessSlider.addEventListener('input', updateImageFilter);
  contrastSlider.addEventListener('input', updateImageFilter);
}

const resetBtn = document.getElementById("reset-image-btn");
resetBtn.addEventListener("click", () => {
  const s = window._initialImageState;
  if (!s) {
    console.warn("No initialImageState—did you upload an image yet?");
    return;
  }

  // restore everything back:
  const c = playerCardImageContainer;
  c.style.width     = s.width;
  c.style.height    = s.height;
  c.style.transform = s.transform;
  c.setAttribute("data-x", s.x);
  c.setAttribute("data-y", s.y);
  positionCornerHandles();
});



const playerImageInput = document.getElementById("player-image");
const playerCardImageContainer = document.getElementById("player-card-image-container");
const playerCardImage = document.getElementById("player-card-image");
playerCardImage.style.visibility = "hidden";

if (playerImageInput && playerCardImageContainer && playerCardImage) {
  playerImageInput.addEventListener("change", function(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = function(e) {
  originalUploadedBase64 = e.target.result.replace(/^data:image\/[^;]+;base64,/, ""); // ✅ Save original
  playerCardImage.src = e.target.result;

  uploadToDrive(originalUploadedBase64, "dynamic-player-image.png").then(url => {
  window.dynamicImageDriveUrl = url;
});



  const handles = document.getElementById("corner-handles-wrapper");
if (handles) {
  handles.style.opacity = "1";
}


  playerCardImage.onload = function() {
    const aspectRatio = playerCardImage.naturalWidth / playerCardImage.naturalHeight;
    const baseHeight = 140;

    playerCardImageContainer.style.height = baseHeight + "px";
    playerCardImageContainer.style.width = (baseHeight * aspectRatio) + "px";

    playerCardImage.style.width = "100%";
    playerCardImage.style.height = "100%";
    playerCardImage.style.visibility = "visible";

    positionCornerHandles();
    enableImageDraggingAndResizing(); // ✅ This is the right place

const c = playerCardImageContainer;
  window._initialImageState = {
    width:     c.style.width,
    height:    c.style.height,
    transform: c.style.transform,
    x:         parseFloat(c.getAttribute("data-x") || 0),
    y:         parseFloat(c.getAttribute("data-y") || 0)
  };
};

  playerCardImageContainer.style.display = "block";
  updateFadeOverlayVisibility();

  playerCardImageContainer.setAttribute("data-x", 0);
  playerCardImageContainer.setAttribute("data-y", 0);
  playerCardImageContainer.style.transform = "translate(0px, 0px)";
};


      reader.readAsDataURL(file);
    } else {
      // If file input is cleared
      playerCardImage.src = "";
      enableImageDraggingAndResizing();  // re-enable drag/resize

      playerCardImageContainer.style.display = "none";
      fadeOverlay.style.display = "none";
    }
  });
}








function enableImageDraggingAndResizing() {
  const container = document.getElementById('player-card-image-container');

  interact(container)
    .resizable({
      edges: { top: true, left: true, bottom: true, right: true },
      listeners: {
        move(event) {
          const target = event.target;
          let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.deltaRect.left;
          let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.deltaRect.top;

          target.style.width = `${event.rect.width}px`;
          target.style.height = `${event.rect.height}px`;
          target.style.transform = `translate(${x}px, ${y}px)`;

          target.setAttribute('data-x', x);
          target.setAttribute('data-y', y);

          positionCornerHandles();
        }
      },
      modifiers: [
        interact.modifiers.aspectRatio({ ratio: 'preserve' }),
        interact.modifiers.restrictSize({ min: { width: 50, height: 50 } })
      ],
      inertia: true
    })
    .draggable({
      listeners: {
        move(event) {
          const target = event.target;
          let x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
          let y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

          target.style.transform = `translate(${x}px, ${y}px)`;
          target.setAttribute('data-x', x);
          target.setAttribute('data-y', y);

          positionCornerHandles();
        }
      }
    });

["top-left", "top-right", "bottom-left", "bottom-right"].forEach(corner => {
  const handle = document.querySelector(`.corner-${corner}`);
  if (!handle) return;

  let resizing = false;

  let startX, startY, startWidth, startHeight, startTransformX, startTransformY;
  const container = document.getElementById("player-card-image-container");

  handle.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    resizing = true;

    startX = e.clientX;
    startY = e.clientY;

    const rect = container.getBoundingClientRect();
    startWidth = rect.width;
    startHeight = rect.height;

    startTransformX = parseFloat(container.getAttribute("data-x")) || 0;
    startTransformY = parseFloat(container.getAttribute("data-y")) || 0;

    document.addEventListener("pointermove", resizeMove);
    document.addEventListener("pointerup", stopResize);
  });

  function resizeMove(e) {
  if (!resizing) return;

  let dx = e.clientX - startX;
  let dy = e.clientY - startY;

  if (corner.includes("left")) dx = -dx;
  if (corner.includes("top")) dy = -dy;

  const delta = Math.max(dx, dy); // unified delta for aspect ratio

  const aspectRatio = startWidth / startHeight;
  const newWidth = Math.max(startWidth + delta, 50);
  const newHeight = newWidth / aspectRatio;

  container.style.width = `${newWidth}px`;
  container.style.height = `${newHeight}px`;

  const newX = startTransformX + (corner.includes("left") ? -delta : 0);
  const newY = startTransformY + (corner.includes("top") ? -(delta / aspectRatio) : 0);

  container.setAttribute("data-x", newX);
  container.setAttribute("data-y", newY);
  container.style.transform = `translate(${newX}px, ${newY}px)`;

  positionCornerHandles();
}


  function stopResize() {
    resizing = false;
    document.removeEventListener("pointermove", resizeMove);
    document.removeEventListener("pointerup", stopResize);
  }
});


}





function updateProgressBar(currentStep) {
  const allBars = [
    document.querySelectorAll("#progress-bar-mobile .step-indicator"),
    document.querySelectorAll("#progress-bar-desktop .step-indicator")
  ];

  allBars.forEach(barSet => {
    barSet.forEach((el, i) => {
      if (i <= currentStep) {
        el.style.backgroundColor = "#d90001";
        el.style.border = "2px solid #d90001";
        el.style.color = "#000";
      } else {
        el.style.backgroundColor = "transparent";
        el.style.color = "#fff";
        el.style.border = "2px solid white";
        
      }
    });
  });
}



 function showStep(index) {
  const stepTitleMobile = document.getElementById("step-title-mobile");
const stepTitleDesktop = document.getElementById("step-title-desktop");

if (stepTitles[index]) {
  if (stepTitleMobile) stepTitleMobile.textContent = stepTitles[index];
  if (stepTitleDesktop) stepTitleDesktop.textContent = stepTitles[index];
}


  updateProgressBar(index);
  console.log("Showing step:", index);
  steps.forEach((step, i) => {
    if (i === index) {
      step.style.removeProperty("display"); // force default
      step.style.display = "block";
    } else {
      step.style.display = "none";
    }
  });

  if (index === 3) {
  // Step 4: Enter player details – default language = English
  const englishBtn = document.querySelector('.language-option[data-lang="en"]');
  if (englishBtn) englishBtn.click();
}


  // 🔄 Toggle corner handles based on step and image presence
  const handles = document.getElementById("corner-handles-wrapper");
  if (handles) {
    if (index < 4) {
      // Before "Upload image" step
      handles.style.opacity = "0";

    } else {
      const playerImage = document.getElementById("player-card-image");
      const hasImage = playerImage &&
        playerImage.src &&
        !playerImage.src.includes("data:image/gif") &&
        !playerImage.src.endsWith("/") &&
        playerImage.src.trim() !== "" &&
        playerImage.src !== window.location.href;

      handles.style.opacity = hasImage ? "1" : "0";

    }
  }


prevBtns.forEach(btn => btn.disabled = index === 0);
nextBtns.forEach(btn => btn.textContent = index === steps.length - 1 ? "Finish" : "Next");


  // Re-bind club tab click handlers ONLY when user is on club step
  if (index === 1) {
    bindClubSuggestionClicks();

  }
}

function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    variantId: params.get('variant'),
    quantity: params.get('quantity') || 1
  };
}


let isSubmitting = false;



function handleNextStep() {
  if (currentStep < steps.length - 1) {
    currentStep++;
    showStep(currentStep);
    return;
  }

  if (isSubmitting) return;
  isSubmitting = true;

  const popup = document.getElementById('stand-popup');
  popup.style.display = 'flex';
  popup.offsetHeight; // force reflow
  popup.style.opacity = '1';

  // ✅ Delay the heavy work just slightly so popup appears instantly
  setTimeout(() => {
    const skipBtn = document.getElementById('skip-stand-btn');
    const standBtn = document.getElementById('add-stand-btn');
    const previewElement = document.getElementById("football-card-preview");
    const { variantId, quantity } = getQueryParams();

    skipBtn.disabled = true;
    standBtn.disabled = true;

    const spinner = document.getElementById("card-loading-spinner");
    spinner.style.display = "block";

    html2canvas(previewElement, {
  useCORS: true,
  scale: 1.0  // 🪄 Shrinks the canvas output size (default is 1; 2 is HD)
}).then(canvas => {
  // Convert to JPEG with 0.75 quality to reduce file size
  const cardBase64 = canvas.toDataURL("image/jpeg", 0.75).replace(/^data:image\/jpeg;base64,/, "");

  uploadToDrive(cardBase64, "final-card.jpg").then(cardUrl => {

        window.cardDriveUrl = cardUrl;

        const properties = {
          'Player Name': document.getElementById("player-name")?.value,
          'Rating': document.getElementById("player-rating")?.value,
          'Position': document.getElementById("player-position")?.value,
          'Pace': document.getElementById("player-pace")?.value,
          'Shooting': document.getElementById("player-shooting")?.value,
          'Passing': document.getElementById("player-passing")?.value,
          'Dribbling': document.getElementById("player-dribbling")?.value,
          'Defending': document.getElementById("player-defending")?.value,
          'Physical': document.getElementById("player-physical")?.value,
          'Nation': document.getElementById("country-input")?.value,
          'League': document.getElementById("league-input")?.value,
          'Club': document.getElementById("club-input")?.value,
          'Language': document.querySelector("#toggle-language-btn span")?.textContent || "",
          'Dynamic Image': window.dynamicImageDriveUrl || "",
          'Card Image': window.cardDriveUrl || "",
          'Custom Flag': window.customFlagDriveUrl || "",
          'Custom League': window.customLeagueDriveUrl || "",
          'Custom Club': window.customClubDriveUrl || ""
        };

        

        spinner.style.display = "none";
        skipBtn.disabled = false;
        standBtn.disabled = false;

        skipBtn.onclick = function () {
          skipBtn.disabled = true;
          fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: parseInt(quantity), properties })
          }).finally(() => {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          });
        };

        standBtn.onclick = function () {
          standBtn.disabled = true;
          fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: parseInt(quantity), properties })
          }).then(() => {
            return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: '41972444823642', quantity: 1 })
            });
          }).finally(() => {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          });
        };
      });
    });
  }, 0); // 🔁 small delay ensures popup renders immediately
}








  showStep(currentStep);

countryInput.addEventListener("input", function () {
  const typed = this.value.trim().toLowerCase();

  const exactMatch = countries.find(c => c.name.toLowerCase() === typed);
  if (exactMatch) {
    countryFlag.src = `https://flagcdn.com/${exactMatch.code}.svg`;
    countryFlag.style.display = "block";
  } else {
    countryFlag.src = "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/new-unknown-flag.png?v=1745591818";
    countryFlag.style.display = "block";
  }

  const matchingCountries = countries.filter(c =>
    c.name.toLowerCase().includes(typed)
  );

  // Make sure we display the "popular" section and highlight that tab
  tabs.forEach(innerTab => {
    document.getElementById(`${innerTab}-tab`).style.backgroundColor = "#374151";
    document.getElementById(`country-suggestions-${innerTab}`).style.display = "none";
  });
  document.getElementById("popular-tab").style.backgroundColor = "#111827";

  const suggestionsContainer = document.getElementById("country-suggestions-popular");
  suggestionsContainer.innerHTML = generateSuggestionsHTML(matchingCountries.map(c => c.name));
  suggestionsContainer.style.display = "grid";

  bindCountrySuggestionClicks(countryInput, countryFlag);

});

const leagueTabs = ["popular", "english"];

leagueTabs.forEach(tab => {
  const tabBtn = document.getElementById(`${tab}-leagues-tab`);
  const section = document.getElementById(`league-suggestions-${tab}`);

  tabBtn.addEventListener("click", () => {
    leagueTabs.forEach(innerTab => {
      document.getElementById(`league-suggestions-${innerTab}`).style.display = "none";
      document.getElementById(`${innerTab}-leagues-tab`).style.backgroundColor = "#374151";
    });

    section.style.display = "grid";
    tabBtn.style.backgroundColor = "#111827";

    bindLeagueSuggestionClicks();
  });
});

document.getElementById("league-suggestions-popular").innerHTML = generateLeagueSuggestionsHTML(popularLeagues);
document.getElementById("league-suggestions-english").innerHTML = generateLeagueSuggestionsHTML(englishLeagues);
bindLeagueSuggestionClicks();


const languageSelect = document.getElementById("language-select");
if (languageSelect) {
  languageSelect.addEventListener("change", function () {
    updateStatLabels(this.value);
    adjustStatGap();
  });
}
}

const popularLeagues = [
  "EPL", "La Liga", "Bundesliga", "Serie A", "Ligue 1", "Eredivisie", "Scottish", "EFL"
];

const englishLeagues = [
  "EPL", "EFL", "EFL L1", "EFL L2"
];




const popularCountries = [
  "England", "France", "Germany", "Spain", "Italy",
  "Portugal", "Netherlands", "Brazil", "Argentina"
];

const asianCountries = [
  "Japan", "South Korea", "China", "India", "Iran",
  "Saudi Arabia", "Qatar", "Thailand", "Vietnam"
];

const europeanCountries = [
  "France", "Germany", "Italy", "Spain", "Portugal", "Netherlands", "Belgium", "England", "Sweden"];

const americanCountries = [
  "Brazil", "Argentina", "United States", "Mexico", "Canada", "Colombia", "Chile", "Peru", "Uruguay"];

const africanCountries = [
  "Nigeria", "Senegal", "Egypt", "Morocco", "Ghana", "Algeria", "Cameroon", "Tunisia", "South Africa"
];

document.getElementById("card-image").src = "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/${filename}";
document.getElementById("card-content").style.color = "#2d2410";
applyMaskOnceReady();



document.getElementById("country-suggestions-popular").innerHTML = generateSuggestionsHTML(popularCountries);
document.getElementById("country-suggestions-asia").innerHTML = generateSuggestionsHTML(asianCountries);
document.getElementById("country-suggestions-europe").innerHTML = generateSuggestionsHTML(europeanCountries);
document.getElementById("country-suggestions-americas").innerHTML = generateSuggestionsHTML(americanCountries);
document.getElementById("country-suggestions-africa").innerHTML = generateSuggestionsHTML(africanCountries);


bindCountrySuggestionClicks();



const tabs = ["popular", "europe", "americas", "africa","asia"];
tabs.forEach(tab => {
  const tabBtn = document.getElementById(`${tab}-tab`);
  const section = document.getElementById(`country-suggestions-${tab}`);

  tabBtn.addEventListener("click", () => {
    // Hide all sections
    tabs.forEach(innerTab => {
      document.getElementById(`country-suggestions-${innerTab}`).style.display = "none";
      document.getElementById(`${innerTab}-tab`).style.backgroundColor = "#374151";
    });

    // Show selected
    section.style.display = "grid";
    tabBtn.style.backgroundColor = "#111827";

    // Re-bind clicks
    bindCountrySuggestionClicks();
  });
});


function bindCountrySuggestionClicks() {
  const countryInput = document.getElementById("country-input");
  const countryFlag = document.getElementById("country-flag");

  document.querySelectorAll(".country-suggestion[data-country]").forEach(button => {
    button.addEventListener("click", () => {
      const selected = button.getAttribute("data-country");
      countryInput.value = selected;

      const match = countries.find(c => c.name === selected);
      if (match) {
        const officialFlagUrl = `https://flagcdn.com/${match.code}.svg`;
        countryFlag.src = officialFlagUrl;
        countryFlag.style.display = "block";
      }
    });
  });
}





function generateSuggestionsHTML(countryList) {
  const limitedList = countryList.slice(0, 8); // Only first 8 countries

  let html = limitedList.map(country => {
    const countryObj = countries.find(c => c.name === country);
    const flagUrl = countryObj
      ? `https://flagcdn.com/w40/${countryObj.code}.png`
      : "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/new-unknown-flag.png?v=1745591818";

    return `
      <button class="country-suggestion" data-country="${country}">
        <img src="${flagUrl}" alt="${country} Flag" class="country-flag-icon">
        <span>${country}</span>
      </button>
    `;
  }).join("");



  // Now insert the 9th slot: Custom Badge
  html += `
    <button style="padding: 5px 0px;" id="custom-country-upload-btn" class="country-suggestion">
      <img src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/customUpload-Icon.png?v=1745779283" alt="Upload Icon" class="custom-upload-icon">
      <span class="custom-span-upload">Upload<br>your<br>flag</span>
    </button>
   
  `;

  return html;
}



const languages = [
  { code: "en", name: "English", flag: "https://flagcdn.com/w40/gb.png" },
  { code: "fr", name: "Français", flag: "https://flagcdn.com/w40/fr.png" },
  { code: "it", name: "Italiano", flag: "https://flagcdn.com/w40/it.png" },
  { code: "de", name: "Deutsch", flag: "https://flagcdn.com/w40/de.png" },
  { code: "es", name: "Español", flag: "https://flagcdn.com/w40/es.png" },
  { code: "nl", name: "Nederlands", flag: "https://flagcdn.com/w40/nl.png" },
  { code: "pt", name: "Português", flag: "https://flagcdn.com/w40/pt.png" },
  { code: "pl", name: "Polski", flag: "https://flagcdn.com/w40/pl.png" },
  { code: "ar", name: "العربية", flag: "https://flagcdn.com/w40/sa.png" },
  { code: "ru", name: "Русский", flag: "https://flagcdn.com/w40/ru.png" },
  { code: "tr", name: "Türkçe", flag: "https://flagcdn.com/w40/tr.png" },
  { code: "sv", name: "Svenska", flag: "https://flagcdn.com/w40/se.png" },
  { code: "no", name: "Norsk", flag: "https://flagcdn.com/w40/no.png" },
  { code: "da", name: "Dansk", flag: "https://flagcdn.com/w40/dk.png" },
  { code: "cs", name: "Čeština", flag: "https://flagcdn.com/w40/cz.png" },
];

function generateLanguageOptions() {
  const panel = document.getElementById("language-select-panel");
  panel.innerHTML = languages.map(lang => `
    <button class="language-option" data-lang="${lang.code}">
      <img src="${lang.flag}" alt="${lang.name} Flag" style="width: 20px; height: 14px;margin: 10px;">
      <span>${lang.name}</span>
    </button>
  `).join("");
}


const toggleLanguageBtn = document.getElementById("toggle-language-btn");
const languageSelectPanel = document.getElementById("language-select-panel");

toggleLanguageBtn.addEventListener("click", () => {
  if (languageSelectPanel.style.display === "none") {
    languageSelectPanel.style.display = "grid";
  } else {
    languageSelectPanel.style.display = "none";
  }
});

document.addEventListener("click", function(event) {
  if (!event.target.closest(".language-select-wrapper")) {
    languageSelectPanel.style.display = "none";
  }
});

function bindLanguageSelection() {
  document.querySelectorAll(".language-option").forEach(button => {
    button.addEventListener("click", () => {
      const lang = button.getAttribute("data-lang");
      updateStatLabels(lang); // your existing function
      adjustStatGap(); // adjust if needed
      toggleLanguageBtn.innerHTML = `
        ${button.innerHTML}
        <span class="arrow">&#9662;</span>
      `;
   
    });
  });
}

// On page load
generateLanguageOptions();
bindLanguageSelection();








const fadeOverlay = document.getElementById("image-fade-overlay");

function updateFadeOverlayVisibility() {
  const playerImage = document.getElementById("player-card-image");

  const hasImage =
    playerImage &&
    playerImage.src &&
    !playerImage.src.includes("data:image/gif") &&
    !playerImage.src.endsWith("/") &&
    playerImage.src.trim() !== "" &&
    playerImage.src !== window.location.href;

  fadeOverlay.style.display = hasImage ? "block" : "none";
}


function adjustStatGap() {
  const container = document.getElementById("stat-labels");
  const statItems = container.querySelectorAll("div");

  if (!container || statItems.length < 2) return;

  const containerWidth = 281.906; // fixed total width
  const itemWidth = statItems[0].offsetWidth; // assumes all items same width
  const totalItemWidth = itemWidth * statItems.length;
  const totalGap = containerWidth - totalItemWidth;
  const gapSize = totalGap / (statItems.length - 1);

  container.style.gap = `${Math.max(gapSize, 0)}px`;
}


function updateStatLabels(lang) {
  const labels = statLabels[lang] || statLabels.en;
  document.getElementById("card-position").textContent = labels.position;

  const keys = ["PAC", "SHO", "PAS", "DRI", "DEF", "PHY"];
  const blocks = document.querySelectorAll(".stat-block");

  blocks.forEach((block, i) => {
    const key = keys[i];
    const span = block.querySelector("span");
    const statValue = span ? span.textContent : "99";
    span.id = `card-${key.toLowerCase()}`;
    span.style = "font-size: 25px;font-weight:800;font-family: 'cruyff_sans_numbers-medium';";
    block.innerHTML = `${labels[key]}<br>` + span.outerHTML;
  });
}











  // --- Update text values from inputs ---
  function updateCardText(inputId, cardId) {
    document.getElementById(inputId).addEventListener("input", function() {
      document.getElementById(cardId).textContent = this.value || "99";
    });
  }
  updateCardText("player-name", "card-name");
  updateCardText("player-rating", "card-rating");
  updateCardText("player-position", "card-position");
  updateCardText("player-pace",    "card-pac");
updateCardText("player-shooting","card-sho");
updateCardText("player-passing", "card-pas");
updateCardText("player-dribbling","card-dri");
updateCardText("player-defending","card-def");
updateCardText("player-physical","card-phy");




function handleCustomUpload(inputId, targetImgId) {
  const input = document.getElementById(inputId);
  const targetImg = document.getElementById(targetImgId);
  if (!input || !targetImg) return;

  input.addEventListener("change", function(event) {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = function(e) {
      targetImg.src = e.target.result;
      targetImg.style.display = "block";

      // ✅ Show corner handles if player image uploaded
      if (targetImg.id === "player-card-image") {
        const handles = document.getElementById("corner-handles-wrapper");
        if (handles) {
          handles.style.opacity = "1";
          handles.style.pointerEvents = "auto";
        }
      }
    };
    reader.readAsDataURL(file);
  } else {
    // ✅ Hide handles if file input cleared
    if (targetImg.id === "player-card-image") {
      const handles = document.getElementById("corner-handles-wrapper");
      if (handles) {
        handles.style.opacity = "0";
        handles.style.pointerEvents = "none";
      }
    }
  }
});


}

// Hook up uploads

handleCustomUpload("upload-league-logo", "league-logo");
handleCustomUpload("upload-club-logo", "club-logo");


  // --- Country input ---
  const countryInput = document.getElementById("country-input");
  const countryFlag = document.getElementById("country-flag");


  // --- Club input ---



const clubInput = document.getElementById("club-input");
const clubLogo = document.getElementById("club-logo");

clubInput.addEventListener("input", function () {
  const typed = this.value.trim().toLowerCase();

  // Update logo if exact match
  const exactMatch = Object.keys(clubs).find(c => c.toLowerCase() === typed);
  if (exactMatch) {
    clubLogo.src = clubs[exactMatch];
    clubLogo.style.display = "block";
  } else {
    clubLogo.src = "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknown-club-badge.png?v=1743862041";
  }

  // Filter matching clubs
  const matchingClubs = Object.keys(clubs).filter(c =>
    c.toLowerCase().includes(typed)
  );

  // Limit to 9 and inject with animation
  const limited = matchingClubs.slice(0, 9);
  const container = document.getElementById("club-suggestions-popular-clubs");

  // Force switch to "Most Popular" tab visually
  clubTabs.forEach(tab => {
    document.getElementById(`club-suggestions-${tab}`).style.display = "none";
    document.getElementById(`${tab}-tab`).style.backgroundColor = "#374151";
  });
  document.getElementById("popular-clubs-tab").style.backgroundColor = "#111827";

  container.innerHTML = limited.map(club => {
    const logoUrl = clubs[club] || "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknown-club-badge.png?v=1743862041";
    return `
      <button class="club-suggestion" data-club="${club}">
        <img src="${logoUrl}" alt="${club} Logo" class="club-icon">
        <span>${club}</span>
      </button>
    `;
  }).join("");

  container.style.display = "grid";

  // Bind click handlers
  bindClubSuggestionClicks();


});


clubInput.addEventListener("focus", function () {
  this.value = "";
  clubLogo.style.display = "none";
});

const laligaClubs = [
  "Real Madrid", "Barcelona", "Atletico Madrid", "Valencia", "Sevilla", "Real Betis", "Real Sociedad", "Villarreal"
];

const premierLeagueClubs = [
  "Man United", "Man City", "Arsenal", "Liverpool", "Chelsea", "Tottenham", "Newcastle United", "Aston Villa"
];

const serieAClubs = ["AC Milan", "Inter Milan", "Juventus", "Napoli", "Roma", "Lazio", "Atalanta", "Fiorentina"];
const ligue1Clubs = ["PSG", "Marseille", "Lyon", "Monaco", "Lille", "Stade Rennais", "OGC Nice", "Lens"];
const bundesligaClubs = ["Bayern Munich", "Borussia Dortmund", "RB Leipzig", "Bayer Leverkusen", "Union Berlin", "Eintracht Frankfurt", "Borussia Mönchengladbach", "Stuttgart"];
const mostPopularClubs = ["Real Madrid", "Barcelona", "Man United", "PSG", "Bayern Munich", "Juventus", "Chelsea", "Arsenal", "Man City"];


// Render club suggestion buttons by league
document.getElementById("club-suggestions-popular-clubs").innerHTML = generateClubSuggestionsHTML(mostPopularClubs);
document.getElementById("club-suggestions-premier").innerHTML = generateClubSuggestionsHTML(premierLeagueClubs);
document.getElementById("club-suggestions-laliga").innerHTML = generateClubSuggestionsHTML(laligaClubs);
document.getElementById("club-suggestions-seriea").innerHTML = generateClubSuggestionsHTML(serieAClubs);
document.getElementById("club-suggestions-ligue1").innerHTML = generateClubSuggestionsHTML(ligue1Clubs);
document.getElementById("club-suggestions-bundesliga").innerHTML = generateClubSuggestionsHTML(bundesligaClubs);
bindCustomClubUpload();
bindCustomLeagueUpload();
bindCustomCountryUpload();
bindClubSuggestionClicks();






function generateClubSuggestionsHTML(clubList) {
  const limited = clubList.slice(0, 8); // Only first 8 clubs

  let html = limited.map(club => {
    const logoUrl = clubs[club] || "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknown-club-badge.png?v=1743862041";
    return `
      <button class="club-suggestion" data-club="${club}">
        <img src="${logoUrl}" alt="${club} Logo" class="club-icon">
        <span>${club}</span>
      </button>
    `;
  }).join("");

  // ✅ Add Custom Club Upload Button (9th slot)
  html += `
    <button style="padding: 5px 0px;" id="custom-club-upload-btn" class="country-suggestion">
      <img src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/customUpload-Icon.png?v=1745779283" alt="Upload Icon" class="custom-upload-icon">
      <span class="custom-span-upload">Upload<br>your<br>club</span>
    </button>
  `;

  return html;
}


const clubTabs = ["popular-clubs", "premier", "laliga", "seriea", "ligue1", "bundesliga"];



clubTabs.forEach(tab => {
  const tabBtn = document.getElementById(`${tab}-tab`);
  const section = document.getElementById(`club-suggestions-${tab}`);

  tabBtn.addEventListener("click", () => {
    clubTabs.forEach(innerTab => {
      document.getElementById(`club-suggestions-${innerTab}`).style.display = "none";
      document.getElementById(`${innerTab}-tab`).style.backgroundColor = "#374151";
    });

    section.style.display = "grid";
    tabBtn.style.backgroundColor = "#111827";

    bindClubSuggestionClicks();


  });
});

function bindClubSuggestionClicks() {
  document.querySelectorAll(".club-suggestion[data-club]").forEach(button => {
    button.addEventListener("click", () => {
      const selectedClub = button.getAttribute("data-club");
      clubInput.value = selectedClub;
      clubLogo.src = clubs[selectedClub] || "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknown-club-badge.png?v=1743862041";
      clubLogo.style.display = "block";
    });
  });
}



function generateLeagueSuggestionsHTML(leagueList) {
  const limited = leagueList.slice(0, 8); // max 8 (only 5 if less)
  let html = limited.map(league => {
    const logoUrl = leagues[league] || "https://cdn.shopify.com/s/files/1/0632/7094/4858/files/unknown-league.png";
    return `
      <button class="league-suggestion" data-league="${league}">
        <img src="${logoUrl}" alt="${league} Logo" class="club-icon">
        <span>${league}</span>
      </button>
    `;
  }).join("");

  // Add Custom League Upload Button
  html += `
    <button style="padding: 5px 0px;" id="custom-league-upload-btn" class="league-suggestion">
      <img src="https://cdn.shopify.com/s/files/1/0632/7094/4858/files/customUpload-Icon.png?v=1745779283" alt="Upload Icon" class="custom-upload-icon">
      <span class="custom-span-upload">Upload<br>your<br>league</span>
    </button>
  `;
  
  return html;
}





function bindLeagueSuggestionClicks() {
  const input = document.getElementById("league-input");

  document.querySelectorAll(".league-suggestion[data-league]").forEach(button => {
    button.addEventListener("click", () => {
      const selectedLeague = button.getAttribute("data-league");
      input.value = selectedLeague;

      // Update logo based on current styleKey
      updateLeagueLogoBasedOnStyle();
    });
  });
}


function bindCustomLeagueUpload() {
  const panel = document.getElementById('league-select-panel');
  const input = document.getElementById('upload-league-logo');
  if (!panel || !input) return;

  panel.addEventListener('click', function (e) {
    if (e.target.closest('#custom-league-upload-btn')) {
      input.click();
    }
  });

  input.addEventListener('change', async function (e) {
    const file = e.target.files[0];
    if (!file) return;

    const leagueImg = document.getElementById("league-logo");
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch("https://api.beast90.com/api/upload-image-to-drive.js", {
        method: "POST",
        body: formData
      });

      if (!response.ok) throw new Error("Drive upload failed");
      const { url } = await response.json();

      window.customLeagueDriveUrl = url;

      const reader = new FileReader();
      reader.onload = function (event) {
        const base64 = event.target.result.replace(/^data:image\/[^;]+;base64,/, "");
        window.customLeagueBase64 = base64;
        leagueImg.src = event.target.result;
        leagueImg.style.display = "block";
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("❌ League upload failed", error);
    }
  });
}



function bindCustomCountryUpload() {
  const panel = document.getElementById('country-select-panel');
  const input = document.getElementById('upload-country-flag');
  if (!panel || !input) return;

  panel.addEventListener('click', function (e) {
    if (e.target.closest('#custom-country-upload-btn')) {
      input.click();
    }
  });

  input.addEventListener('change', async function (e) {
    const file = e.target.files[0];
    if (!file) return;

    const flagImg = document.getElementById("country-flag");
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch("https://api.beast90.com/api/upload-image-to-drive.js", {
        method: "POST",
        body: formData
      });

      if (!response.ok) throw new Error("Drive upload failed");
      const { url } = await response.json();

      window.customFlagDriveUrl = url;

      const reader = new FileReader();
      reader.onload = function (event) {
        const base64 = event.target.result.replace(/^data:image\/[^;]+;base64,/, "");
        window.customFlagBase64 = base64;
        flagImg.src = event.target.result;
        flagImg.style.display = "block";
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("❌ Flag upload failed", error);
    }
  });
}



function bindCustomClubUpload() {
  const panel = document.getElementById('club-select-panel');
  const input = document.getElementById('upload-club-logo');
  if (!panel || !input) return;

  panel.addEventListener('click', function (e) {
    if (e.target.closest('#custom-club-upload-btn')) {
      input.click();
    }
  });

  input.addEventListener('change', async function (e) {
    const file = e.target.files[0];
    if (!file) return;

    const clubImg = document.getElementById("club-logo");
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch("https://api.beast90.com/api/upload-image-to-drive.js", {
        method: "POST",
        body: formData
      });

      if (!response.ok) throw new Error("Drive upload failed");
      const { url } = await response.json();

      window.customClubDriveUrl = url; // ✅ Save for Google Sheets later

      const reader = new FileReader();
      reader.onload = function (event) {
        const base64 = event.target.result.replace(/^data:image\/[^;]+;base64,/, "");
        window.customClubBase64 = base64;
        clubImg.src = event.target.result;
        clubImg.style.display = "block";
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error("❌ Upload failed", error);
    }
  });
}











  window.addEventListener("load", adjustStatGap);
window.addEventListener("resize", adjustStatGap);







});
document.addEventListener('DOMContentLoaded', () => {

    document.body.addEventListener("change", function (e) {
    if (e.target.id === "player-image") {
      const fileNameDisplay = document.getElementById("file-name");
      if (e.target.files.length > 0) {
        fileNameDisplay.textContent = e.target.files[0].name;
      } else {
        fileNameDisplay.textContent = "";
      }
    }
  });

function getQueryParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    variantId: params.get('variant'),
    quantity: params.get('quantity') || 1
  };
}


  const removeBgBtn = document.getElementById('remove-bg-btn');
  const outputImg = document.getElementById('output-img');
  const uploadInput = document.getElementById('player-image');

  let selectedFile = null;

  if (uploadInput) {
  uploadInput.addEventListener('change', (e) => {
    selectedFile = e.target.files[0];
    console.log("📸 File selected:", selectedFile);
  });
}



  removeBgBtn.addEventListener('click', async () => {
  console.log("🟩 Remove Background button clicked");

  if (!selectedFile) {
    alert("Please select a file first.");
    return;
  }

  // Animate button
  removeBgBtn.textContent = "Removing...";
  removeBgBtn.style.backgroundImage = "linear-gradient(90deg, #4b5563 0%, #10b981 50%, #4b5563 100%)";
  removeBgBtn.style.backgroundSize = "300% 100%";
  removeBgBtn.style.animation = "loadingGradient 1.8s ease-in-out infinite alternate";

  const formData = new FormData();
  formData.append('image', selectedFile);

  const playerImage = document.getElementById('player-card-image');
  const container = document.getElementById('player-card-image-container');

  // 🔒 Save current position + size
  const savedStyles = {
    width: container.style.width,
    height: container.style.height,
    transform: container.style.transform,
    x: container.getAttribute("data-x"),
    y: container.getAttribute("data-y")
  };

  // Set this before assigning new src to restore layout
  playerImage.onload = () => {
    container.style.width = savedStyles.width;
    container.style.height = savedStyles.height;
    container.style.transform = savedStyles.transform;
    container.setAttribute("data-x", savedStyles.x);
    container.setAttribute("data-y", savedStyles.y);

    playerImage.style.width = "100%";
    playerImage.style.height = "100%";
    playerImage.style.visibility = "visible";

    positionCornerHandles();
    updateFadeOverlayVisibility();
  };

  try {
    const response = await fetch('https://beast90.vercel.app/api/remove-bg', {
      method: 'POST',
      body: formData,
    });

    const contentType = response.headers.get('content-type');

    if (contentType && contentType.includes('application/json')) {
      const result = await response.json();
      console.log("✅ JSON result:", result);
      playerImage.src = result.output_url;
    } else {
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      console.log("✅ Binary response (likely image)");
      playerImage.src = url;
    }

  } catch (error) {
    console.error("❌ Error removing background:", error);
    removeBgBtn.textContent = "Error ❌";
  } finally {
    removeBgBtn.textContent = "Remove Background";
    removeBgBtn.style.backgroundImage = "";
    removeBgBtn.style.backgroundSize = "";
    removeBgBtn.style.animation = "";
  }
});


function updateStepContainerMinWidth() {
  const stepContainer = document.querySelector('.step-container');
  if (!stepContainer) return;

  const viewportWidth = window.innerWidth;
  const calculatedMinWidth = viewportWidth - 50;
  const finalMinWidth = Math.min(calculatedMinWidth, 450); // cap at 450px

  stepContainer.style.minWidth = `${finalMinWidth}px`;
}

// Run on load
window.addEventListener('DOMContentLoaded', updateStepContainerMinWidth);

// Run on resize
window.addEventListener('resize', updateStepContainerMinWidth);

let lastTouchEnd = 0;
document.addEventListener('touchend', function (event) {
  const now = new Date().getTime();
  if (now - lastTouchEnd <= 300) {
    event.preventDefault();
  }
  lastTouchEnd = now;
}, false);

 document.addEventListener('gesturestart', e => e.preventDefault());
  document.addEventListener('gesturechange', e => e.preventDefault());
  document.addEventListener('gestureend', e => e.preventDefault());

});


  (function(){
    let startX, startY;
    document.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchmove', e => {
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy)) e.preventDefault();
    }, { passive: false });
  })();
